import "./lleMainPage.css";
import React, { useState, useEffect, createContext, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { GET_STAKEHOLDER_BY_URN, UPDATE_LLE, GET_ADDRESS_BY_IFSC, authKey, UPLOAD_DCUMENT, ResourceUpdateMember, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../../common/URLs'
import jwt from 'jwt-decode';
import moment from "moment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ROLES, API_DATE_FORMAT, BANK_CANCELLED_CHEQUE, BASIC_DATE_FORMAT, ID_PROOF, LABOUR_LICENCE, PAN_CARD, PHOTO, SAVE_EXIT_API, SUBMIT_API, LLE_TRADE_LICENSE, GOV_ID_LIST, EMPTY_FIELD_ERROR, CONSTANTS, LAND_AREA_UNIT, RESOURCE_ROLES } from "../../../../common/constants";
import resolveIcon from "../../../../images/resolved.png";
import { BLOCK_LIST, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE } from "../../../../common/constants";
import { loaderService } from "../../../../common/custom-loader/loader-service";
import { GEOCODE_LOCATION, GST, LOI_ABRPL_AGREEMENT, NON_ENCUMBRANCE_CERTI, VALATION_REPORT } from "../../../../common/constants";
import { GET_ALL_BLOCKLIST_AND_REVENUECIRCLE } from '../../../../common/URLs';
import { APPLICATION_ADDRESS_EVIDENCE, EXISTING_OCC, GENDER, HIGHEST_QUALIFICATION, MOA_REGISTRATION_CERTIFICATE, SALUTATION, DATE_RANGE_ERROR } from '../../../../common/constants';
import { MOBILE_NO_ERROR, INVALID_OTP_ERROR } from '../../../../common/constants';
import { sendOTP, validateOTP } from '../../../../common/Utils';
import { ADJACENT_DISTRICT, BEYOND_25_KM, OTHER_DISTRICT, WITHIN_25_KM, MORE_THAN_4_BIGAH, BTWN_3_4_BIGAH } from '../../../../common/constants';
import { LAND_DOCUMENT } from '../../../../common/constants';
import { BTWN_100_500_METER, BTWN_4_6_HR, BTWN_500_1_METER, BTWN_6_8_HR, MORE_THAN_8_HR, ROAD_PHOTO, WITHIN_100_METER } from '../../../../common/constants';
import { accountNumberLimit, emailValidation, nameValidation, landAreaValidation, maxNameLength, pincodeMaxLength, approverCommentMaxLength, urnMaxLength } from "../../../../common/commonValidations";
import { CommonPincodeMUI } from "../../../../common/common-pincode/commonPincodeMUI";
import { checkDateValidation, VALIDATION } from "../../../../common/commonValidations";
import Preview from '../preview';
import { getLocalStorageItem } from "../../../../common/localStorageUtils";
import { PROD } from "../../../../common/constants";
import { appCountDisplay } from '../dashboardStakeHolder';
import { Container, Switch, Card, RadioGroup, Radio, Button, IconButton, ToggleButton, CardContent, ToggleButtonGroup, InputAdornment, Divider, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { LocationPointMUI } from "../../../../common/locationPoints/locationPointMUI";
import BackButton from "../../../../common/backButton";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../../common/commonPopovers/confirmationPopover";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';
import { CheckCircle as TickIcon, Search as SearchIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { getAllComments, insertComment } from "../commonRegistrationStakeholderAPIs";
import { GetRecentCommentObject, handleNumberFieldFocus } from "../../../../common/commonFunction";
import { DataGrid } from '@mui/x-data-grid';
import { PreviewIcon, SaveIcon } from "../../../../common/icons";
import _ from 'lodash';
import BadgeComponent from '../../../../common/badge';
import { addressMaxLength, emailUrnPassMaxLength, mobileNoMaxLength, govtIDcardLength, totalClumpsMaxLength, mobileNumberValidation, otpMaxLength, pincodeValidation, plotValidationForKatha, plotValidationForOtherUnits, totalNumberOfClumpValidation, totalPlotsMaxLength } from '../../../../common/commonValidations';
import { appInsights } from "../../../../AppInsights";
import apiClient from "../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';



const LleContext = createContext();

const RegistrationDetailsLle = (props) => {
  const { state } = useLocation();
  let uuid = localStorage.getItem('uuid');
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [verifyMobileNo, setVerifyMobileNo] = useState(false);
  const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
  const [otpHidden, setOtpHidden] = useState(true);
  const [preview, setPreview] = useState(false);
  const [pincodeAddressDetails, setPincodeAddressDetails] = useState();
  const [personalRevenueCircleBlocklistLabel, setPersonalRevenueCircleBlocklistLabel] = useState(REVENUE_BLOCK_DEFAULT_VALUE);
  const [contactPersonDetails, setContactPersonDetails] = useState({
    contactPersonFirstName: '',
    contactPersonMiddleName: '',
    contactPersonLastName: '',
    contactPersonSalutation: 'Mr',
    contactPersonGender: 'Male',
  });
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleConfirmLogModalClose = () => setLogModalOpen(false);
  const [documentArray, setDocumentArray] = useState([]);
  const [otherIdType, setOtherIdType] = useState();
  const [details, setDetails] = useState({
  });
  const [updatedDetails, setUpdatedDetails] = useState({});
  const [errorMessage, setErrorMessage] = useState({
    nameError: "",
    contactPersonFirstNameError: '',
    emailIdError: '',
    mobileNoError: "",
    govtIdCardTypeError: "",
    govtIdCardNumberError: "",
    panNumberError: "",
    bankAccountNumberError: "",
    gstNoError: "",
    bankAccountHolderNameError: "",
    bankBranchError: "",
    bankIfscCodeError: "",
    registrationNoError: '',
    educationQualificationError: '',
    netWorthError: '',
    workingCapitalError: '',
    typeOfOccError: '',
    documentError: '',
    idProofDocError: '',
    highestQualiDocError: '',
    regCertDocError: '',
    existingOCCDocError: '',
    valuationDocError: '',
    tradeLicenseDocError: '',
    nonEncumDocError: '',
    bankDocError: '',
    landDocError: '',
    roadPicError: '',
    landPicError: '',
    gstDocError: '',
    otherCardError: '',
    agreementDocError: '',
    otherCardError: '',
    agreementDocError: ''
  });
  const [id, setId] = useState('');
  const [lleDetails, setLleDetails] = useState();
  const urn = state?.URN ? state.URN : props.urn;
  const [applicantType, setApplicantType] = useState();
  const [otpValue, setOtpValue] = useState();
  const [fullName, setFullName] = useState('');
  const [contactPersonFirstName, setContactPersonFirstName] = useState('');
  const [contactPersonMiddleName, setContactPersonMiddleName] = useState('');
  const [contactPersonLastName, setContactPersonLastName] = useState('');
  const [contactPersonSalutation, setContactPersonSalutation] = useState('');
  const [contactPersonGender, setContactPersonGender] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [emailId, setEmailId] = useState('');
  const [landAreaValue, setLandAreaValue] = useState('');
  const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
  const [address, setAddress] = useState('');
  const [chippingAddress, setChippingAddress] = useState('');
  const [pincode, setPincode] = useState('');
  const [states, setStates] = useState('');
  const [district, setDistrict] = useState('');
  const [revenueCircle, setRevenueCircle] = useState('');
  const [blockLists, setBlockLists] = useState('');
  const [chippingPincode, setChippingPincode] = useState('');
  const [chippingState, setChippingState] = useState('');
  const [chippingDistrict, setChippingDistrict] = useState('');
  const [chippingRevenueCircle, setChippingRevenueCircle] = useState('');
  const [chippingBlockLists, setChippingBlocklists] = useState('');
  const [govIDType, setGovIDType] = useState("Aadhaar ID");
  const [govIDNumber, setGovIDNumber] = useState('');
  const [govIDNumberVisible, setGovIDNumberVisible] = useState(false);
  const [educationQualification, setEducationQualification] = useState('');
  const [existingOccupation, setExistingOccupation] = useState('');
  const [registrationNo, setRegistrationNo] = useState('');
  const [panNumber, setPanNumber] = useState('');
  const [registrationtrue, setRegistrationtrue] = useState();
  const [labourLicenseNo, setLabourLicenseNo] = useState('');
  const [labourLicenseEndDate, setLabourLicenseEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
  const [labourLicenseEndDateDisplay, setLabourLicenseEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));

  const [tradeLicenseNo, setTradeLicenseNo] = useState('');
  const [tradeLicenseEndDate, setTradeLicenseEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
  const [tradeLicenseEndDateDisplay, setTradeLicenseEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
  const [netWorth, setNetWorth] = useState('');
  const [workingCapital, setWorkingCapital] = useState('');
  // Bank Details
  const [bankDetails, setBankDetails] = useState();
  const [accountNumber, setAccountNumber] = useState('');
  const [accountHolderName, setAccountHolderName] = useState('');
  const [branchName, setBranchName] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [bankName, setBankName] = useState('');
  const [quantitylle, setQuantitylle] = useState('');
  const [landArealle, setLandArealle] = useState('');
  const [apiResponse, setApiResponse] = useState();
  const [apiError, setApiError] = useState();

  const [gstNo, setGstNo] = useState('');
  const [nonEncumbranceCertificateNo, setNonEncumbranceCertificateNo] = useState('');
  const [agreementStartDate, setAgreementStartDate] = useState();
  const [agreementEndDate, setAgreementEndDate] = useState();
  const [agreementStartDateDisplay, setAgreementStartDateDisplay] = useState();
  const [agreementEndDateDisplay, setAgreementEndDateDisplay] = useState();
  const [hidden, setHidden] = useState({
    divPreview: true
  });
  const [chippingRevenueCircleBlocklistLabel, setchippingRevenueCircleBlocklistLabel] = useState('Revenue Circle/Block Office');
  const [chippingRevenueCircleAndBlockList, setchippingRevenueCircleAndBlockList] = useState([]);
  const [chippingPincodeDetails, setchippingPincodeDetails] = useState();
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [applicantAddressRangeFromOperationArea, setApplicantAddressRangeFromOperationArea] = useState(WITHIN_25_KM);
  const [landAvailability, setLandAvailability] = useState(MORE_THAN_4_BIGAH);
  const [landType, setLandType] = useState("Owned");
  const [showOwnedLabel, setOwnedLabel] = useState(true);
  const [showLeasedLabel, setLeasedLabel] = useState(false);
  const [roadConnectivity, setRoadConnectivity] = useState("Adjacent to an existing bitumen/block road");
  const [optedLocationPowerConnectionDistance, setOptedLocationPowerConnectionDistance] = useState(WITHIN_100_METER);
  const [daytimePowerAvailability, setDaytimePowerAvailability] = useState(MORE_THAN_8_HR);

  const [nextClick, setNextClick] = useState(0);
  const [loc, setLoc] = useState();
  const decoded = jwt(getLocalStorageItem('id_token'));

  // comment section code
  const [commentsData, setCommentsData] = useState();
  const [comments, setComments] = useState([]);
  let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
  let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
  let agreementComments = comments?.filter((item) => item.sectionName === "agreement_details");
  let qualificationComments = comments?.filter((item) => item.sectionName === "qualification_details");
  let chippingLocationComments = comments?.filter((item) => item.sectionName === "chippingLocation_details");
  let locationComments = comments?.filter((item) => item.sectionName === "location_details");
  const [personalComment, setPersonalComment] = useState("");
  const [bankComment, setBankComment] = useState("");
  const [agreementComment, setAgreementComment] = useState("");
  const [qualificationComment, setQualificationComment] = useState("");
  const [chippingLocationComment, setChippingLocationComment] = useState("");
  const [locationComment, setLocationComment] = useState("");
  const [characterLimit] = useState(300);
  const [expandedSection, setExpandedSection] = useState("personal");
  const [currentPage, setCurrentPage] = useState("registrationDetails");
  const [buttonAction, setButtonAction] = useState("");
  const [callUpdateApi, setCallUpdateApi] = useState(false);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
  const [stakeHolderDetails, setStakeHolderDetails] = useState();
  const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
  const [showClarificationButton, setShowClarificationButton] = useState(false);
  const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
  const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
  const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
  const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
  const [qualificationDetailsSectionOk, setQualificationDetailsSectionOk] = useState(false);
  const [locationDetailsSectionOk, setLocationDetailsSectionOk] = useState(false);
  const [chippingLocationDetailsSectionOk, setChippingLocationDetailsSectionOk] = useState(false);
  const [shouldActOnSection, setShouldActOnSection] = useState({
    personal_details: false,
    bank_details: false,
    agreement_details: false,
    qualification_details: false,
    chippingLocation_details: false,
    location_details: false
  });
  const [callWorkFlowApi, setCallWorkFlowApi] = useState(false);
  const [isMSMERadio, setIsMSMERadio] = useState('NO');
  const [msmeCategory, setMsmeCategory] = useState('');
  const MSME_CATEGORY_OPTIONS = [
    { key: "MSM1", description: "Micro:Goods Mnfg/Spl" },
    { key: "MSM2", description: "Micro:Service Provdr" },
    { key: "MSM3", description: "Small:Goods Mnfg/Spl" },
    { key: "MSM4", description: "Small:Service Provdr" },
    { key: "MSM5", description: "Medium:Good Mnfg/Spl" },
    { key: "MSM6", description: "Medium:Service Provdr" },
    { key: "MSM7", description: "Other:Goods Mnfg/Spl" },
    { key: "MSM8", description: "Other:Service Provdr" },
    { key: "OTHER", description: "Others" }
  ];

  useEffect(() => {
    setUpdatedDetails(prev => ({
      ...prev,
      isMSME: isMSMERadio === 'YES' ? 1 : 0,
      msmeCategory: isMSMERadio === 'NO' ? '' : msmeCategory
    }));
  }, [isMSMERadio, msmeCategory]);


  let userRole = localStorage.getItem('role');

  const onSaveComment = (comment, sectionName, sectionOk) => {
    const commentObject = {
      comment: comment,
      stakeholderMasterId: lleDetails?.lleMasters[0]?.regStakeholderMasterId,
      sectionName: sectionName,
      sectionId: lleDetails?.lleMasters[0]?.id,
      sectionOk: sectionOk,
      userRole: localStorage.getItem('role'),
      createdBy: decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid,
    }
    comment ? insertComment([commentObject], lleDetails?.lleMasters[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
    setPersonalComment("");
    setBankComment("")
    setAgreementComment("");
    setQualificationComment("");
    setChippingLocationComment("");
    setLocationComment("");
    setErrorMessage({ ...errorMessage, qualificationCommentError: "", chippingLocationCommentError: "", locationCommentError: "", personalCommentError: "", bankCommentError: "", agreementCommentError: "", vehicleCommentError: "" });
  }

  const commentsColumn = [
    {
      field: 'comment', headerName: t('reg.comments'), width: 330,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
            {params.value.split('<br />').map((line, index) => (
              <>
                {line}
                <br />
              </>
            ))}
          </div>
        )
      }
    },
    {
      field: 'createdByName', headerName: t('preReg.name'), width: 200
    },
    {
      field: 'userRole', headerName: t('reg.userRole'), width: 200
    },
    {
      field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
    },
  ]


  useEffect(() => {
    if (urn) {
      getLleDetailsFromUrn();
    }
  }, [urn]);

  const getLleDetailsFromUrn = () => {
    loaderService.showLoader();
    apiClient.post(GET_STAKEHOLDER_BY_URN,
      {
        "urn": urn,
        "type": "lle",
        "isScrutinyView": "true"
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        loaderService.hideLoader();
        setLleDetails(response.data.stakeHolder);
        let stakeHolderDetailsLocal = response.data.stakeHolder;
        setStakeHolderDetails(response.data.stakeHolder);
        if (stakeHolderDetailsLocal) {
          const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid
          if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
            &&
            (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)
          ) {
            setShowCommentSection(true);
          }
          if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
            setShowCommentSection(true);
            setRegScruResourceUpdate(true);
          }
          if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected" && (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated"))) || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && !stakeHolderDetailsLocal?.registrationCompleted) || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved"))) {
            setEnableSaveSubmitButtons(true);
          }
          if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
            if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus === "Pending_Clarification") {
              setShowClarificationButton(true);
              setEnableSaveSubmitButtons(true);
              setShowWorkFlowButtons(false);
            } else if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus !== "Pending_Clarification")) {
              setShowWorkFlowButtons(true);
              setShowClarificationButton(false);
            } else {
              setShowWorkFlowButtons(false);
              setShowClarificationButton(false);
            }
          } else {
            setShowWorkFlowButtons(false);
            setShowClarificationButton(false);
          }
          getAllComments(stakeHolderDetailsLocal?.lleMasters[0]?.regStakeholderMasterId, setCommentsData);
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  useEffect(() => {
    if (lleDetails) {
      let docType = lleDetails?.lleMasters[0].documents
      let tradeLicenseEndDateApiValue = lleDetails.lleMasters[0].tradeLicenceEndDate ? lleDetails.lleMasters[0].tradeLicenceEndDate : moment(new Date()).format(API_DATE_FORMAT)
      let labourLicenseEndDateApiValue = lleDetails.lleMasters[0].labourLicenceEndDate ? lleDetails.lleMasters[0].labourLicenceEndDate : moment(new Date()).format(API_DATE_FORMAT)
      let agreementStartDateApiValue = lleDetails?.lleMasters[0].agreementStartDate
      let agreementEndDateApiValue = lleDetails?.lleMasters[0].agreementEndDate

      const spaceIndex = lleDetails.lleMasters[0]?.landArea?.indexOf(" ");
      const numberPart = lleDetails.lleMasters[0]?.landArea ? lleDetails.lleMasters[0]?.landArea?.slice(0, spaceIndex) : '';

      const unitPart = lleDetails.lleMasters[0]?.landArea ? lleDetails.lleMasters[0]?.landArea?.slice(spaceIndex + 1) : 'sq ft';

      setApplicantType(lleDetails.lleMasters[0].applicantType)
      setId(lleDetails?.id)
      setFullName(lleDetails.name)
      setContactPersonSalutation(lleDetails.contactPersonSalutation)
      setContactPersonFirstName(lleDetails.contactPersonFirstname)
      setContactPersonMiddleName(lleDetails.contactPersonMiddlename)
      setContactPersonLastName(lleDetails.contactPersonLastname)
      setContactPersonGender(lleDetails.contactPersonGender)
      setMobileNumber(lleDetails.mobileNo)
      setEmailId(lleDetails.emailId)
      setLandAreaValue(numberPart);
      setLandAreaUnit(unitPart);
      setAddress(lleDetails.lleMasters[0].address)
      setPincode(lleDetails.lleMasters[0].pincode)
      setStates(lleDetails.lleMasters[0].state)
      setDistrict(lleDetails.lleMasters[0].district)
      setRevenueCircle(lleDetails.lleMasters[0].revenueCircle)
      setBlockLists(lleDetails.lleMasters[0].blockName)
      setChippingAddress(lleDetails.lleMasters[0].chippingUnitAddress)
      setChippingPincode(lleDetails.lleMasters[0].chippingUnitPincode)
      setChippingState(lleDetails.lleMasters[0].chippingUnitState)
      setChippingDistrict(lleDetails.lleMasters[0].chippingUnitDistrict)
      setChippingRevenueCircle(lleDetails.lleMasters[0].chippingUnitRevenueCircle)
      setChippingBlocklists(lleDetails.lleMasters[0].chippingUnitBlockName)
      setLatitude(lleDetails.lleMasters[0].chippingUnitLatitude)
      setLongitude(lleDetails.lleMasters[0].chippingUnitLongitude)
      setQuantitylle(lleDetails.lleMasters[0].estimatedBambooQuantity)
      setLandArealle(lleDetails.lleMasters[0].estimatedLandArea)
      setMobileOTPValidated(lleDetails.isOtpValidated)
      setLandType(lleDetails.lleMasters[0].landType)
      setApplicantAddressRangeFromOperationArea(lleDetails.lleMasters[0].applicantAddressRangeFromOperationArea)
      setLandAvailability(lleDetails.lleMasters[0].landAvailability)
      setRoadConnectivity(lleDetails.lleMasters[0].roadConnectivity)
      setDaytimePowerAvailability(lleDetails.lleMasters[0].daytimePowerAvailability)
      setOptedLocationPowerConnectionDistance(lleDetails.lleMasters[0].optedLocationPowerConnectionDistance)
      setContactPersonDetails({
        ...contactPersonDetails,
        contactPersonFirstName: lleDetails.contactPersonFirstname,
        contactPersonMiddleName: lleDetails.contactPersonMiddlename,
        contactPersonLastName: lleDetails.contactPersonLastname,
        contactPersonSalutation: lleDetails.contactPersonSalutation ? lleDetails.contactPersonSalutation : 'Mr',
        contactPersonGender: lleDetails.contactPersonGender ? lleDetails.contactPersonGender : 'Male',

      });
      setEducationQualification(lleDetails.lleMasters[0].highestEducationalQualification)
      setRegistrationNo(lleDetails.lleMasters[0].registrationNumber)
      setExistingOccupation(lleDetails.lleMasters[0].existingOccupation)
      setGovIDType(lleDetails.govtIdCardType ? lleDetails.govtIdCardType : lleDetails.lleMasters[0].applicantType === 'Individual' ? "Aadhaar ID" : "MOA")
      setGovIDNumber(lleDetails.govtIdCardNumber)
      setGovIDNumberVisible(lleDetails.govtIdCardType === "Aadhaar ID" ? true : false)
      setOtherIdType(lleDetails.otherGovtCardType)
      setPanNumber(lleDetails.panNumber)
      setLabourLicenseNo(lleDetails.lleMasters[0].labourLicenceNumber)
      setTradeLicenseNo(lleDetails.lleMasters[0].tradeLicenceNumber)
      setAccountHolderName(lleDetails.bankAccountHolderName)
      setAccountNumber(lleDetails.bankAccountNumber)
      setIfscCode(lleDetails.bankIfscCode)
      setBankName(lleDetails.bankName)
      setBranchName(lleDetails.bankBranch)
      setTradeLicenseEndDate(tradeLicenseEndDateApiValue ? tradeLicenseEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
      setTradeLicenseEndDateDisplay(tradeLicenseEndDateApiValue ? moment(tradeLicenseEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
      setLabourLicenseEndDate(labourLicenseEndDateApiValue ? labourLicenseEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
      setLabourLicenseEndDateDisplay(labourLicenseEndDateApiValue ? moment(labourLicenseEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
      setGstNo(lleDetails.lleMasters[0].gstNumber)
      setNonEncumbranceCertificateNo(lleDetails.lleMasters[0].nonEncumbranceCertificateNo)
      setNetWorth(lleDetails.lleMasters[0].netWorth)
      setWorkingCapital(lleDetails.lleMasters[0].workingCapital)
      setAgreementEndDate(agreementEndDateApiValue)
      setAgreementStartDate(agreementStartDateApiValue)
      setAgreementStartDateDisplay(agreementStartDateApiValue && moment(agreementStartDateApiValue).format(BASIC_DATE_FORMAT))
      setAgreementEndDateDisplay(agreementEndDateApiValue && moment(agreementEndDateApiValue).format(BASIC_DATE_FORMAT))
      setRegistrationtrue(lleDetails.registrationCompleted)
      setDocumentArray(lleDetails.lleMasters[0].documents)
      setIsMSMERadio(
        lleDetails?.isMSME === 1 ? 'YES' : 'NO'
      );

      setMsmeCategory(
        lleDetails?.msmeCategory || lleDetails?.msmeType || ''
      );
    }

  }, [lleDetails]);

  useEffect(() => {
    if (callUpdateApi) {
      appInsights.trackEvent({
        name: 'Details Changed',
        properties: {
          timeStamp: new Date().toISOString(),
          user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
        }
      })
      if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
        onCheckUserDistrictMapping();
      }
      else updateLle();
    }
  }, [callUpdateApi]);

  const onCheckUserDistrictMapping = () => {
    loaderService.showLoader();
    apiClient.post(CHECK_USER_DISTRICT_MAPPING,
      {
        "state": stakeHolderDetails?.lleMasters?.[0]?.state,
        "plotDistrict": stakeHolderDetails?.lleMasters?.[0]?.district
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          updateLle();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  useEffect(() => {
    const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
    setComments(commentsData);
    let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
    let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
    let agreementCommentsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
    let qualificationCommentsInitial = commentsData?.filter((item) => item.sectionName === "qualification_details");
    let chippingLocationCommentsInitial = commentsData?.filter((item) => item.sectionName === "chippingLocation_details");
    let locationCommentsInitial = commentsData?.filter((item) => item.sectionName === "location_details");
    setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
    setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
    setAgreementDetailsSectionOk(GetRecentCommentObject(agreementCommentsInitial)?.sectionOk ? GetRecentCommentObject(agreementCommentsInitial)?.sectionOk : false);
    setQualificationDetailsSectionOk(GetRecentCommentObject(qualificationCommentsInitial)?.sectionOk ? GetRecentCommentObject(qualificationCommentsInitial)?.sectionOk : false);
    setChippingLocationDetailsSectionOk(GetRecentCommentObject(chippingLocationCommentsInitial)?.sectionOk ? GetRecentCommentObject(chippingLocationCommentsInitial)?.sectionOk : false);
    setLocationDetailsSectionOk(GetRecentCommentObject(locationCommentsInitial)?.sectionOk ? GetRecentCommentObject(locationCommentsInitial)?.sectionOk : false);
    if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
    }
    else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
    }
    else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
      Object.keys(shouldActOnSection).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
        shouldActOnSection[key] = !section?.sectionOk;
      });
    }
    else {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = true;
      });
    }
  }, [commentsData]);

  const onGoBack = () => {
    setCurrentPage("registrationDetails")
  }

  const noCommentForMandatorySections = () => {
    if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
      if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "qualification_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "qualification_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("qualification");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, qualificationCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "chippingLocation_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "chippingLocation_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("chippingLocation");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, chippingLocationCommentError: "Please enter comment and save" });
        return true;
      }
      if (comments.find((item) => item.sectionName === "location_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "location_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("location");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, locationCommentError: "Please enter comment and save" });
        return true;
      }
    }
    else {
      if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        return true;
      }
      if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" })
        return true;
      }
      if (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        return true;
      }
      if (shouldActOnSection.qualification_details && !comments.find((item) => item.sectionName === "qualification_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("qualification");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, qualificationCommentError: "Please enter comment and save" })
        return true;
      }
      if (shouldActOnSection.chippingLocation_details && !comments.find((item) => item.sectionName === "chippingLocation_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("chippingLocation");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, chippingLocationCommentError: "Please enter comment and save" })
        return true;
      }
      if (shouldActOnSection.location_details && !comments.find((item) => item.sectionName === "location_details" && item.createdBy === (decoded.extension_URN ? lleDetails?.lleMasters[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("location");
        // toast.error("Please enter comment and save");
        setErrorMessage({ ...errorMessage, locationCommentError: "Please enter comment and save" })
        return true;
      }
    }
    return false
  }

  // const showPreview = () => {
  //   if (showCommentSection && (noCommentForMandatorySections())
  //   ) {
  //     toast.error("Please enter comments for required sections");
  //   }
  //   else {
  //     Object.keys(finalData?.lleDetail).forEach((key) => {
  //       if (!_.isEqual(finalData?.lleDetail[key], initialData?.lleDetail[key])) {
  //         console.log(`Mismatch at key: ${key}`);
  //         console.log('Initial:', initialData?.lleDetail[key]);
  //         console.log('Final:', finalData?.lleDetail[key]);
  //       }
  //     });
  //     setErrorMessage({ ...errorMessage, landDetailsError: "" });
  //     enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
  //     setButtonAction("preview")
  //   }
  // }

  const showPreview = () => {
  if (showCommentSection && noCommentForMandatorySections()) {
    toast.error("Please enter comments for required sections");
    return;
  }

  setErrorMessage((prev) => ({ ...prev, landDetailsError: "" }));

  const finalData = getFinalData();

  //  Debugging: Logs specific field mismatches to console if save isn't triggering
  // if (process.env.NODE_ENV !== 'production') {
  //   Object.keys(finalData || {}).forEach((key) => {
  //     if (!_.isEqual(finalData[key], initialData?.[key])) {
  //       console.log(`[Change Detected] Key: "${key}"`, {
  //         initial: initialData?.[key],
  //         current: finalData[key],
  //       });
  //     }
  //   });
  // }

  const hasChanged = !_.isEqual(finalData, initialData);

  if (enableSaveSubmitButtons && hasChanged) {
    setCallUpdateApi(true);
  } else {
    setCurrentPage("preview");
  }

  setButtonAction("preview");
};

  const enableFieldFunction = (sectionEnabled, isPreg, isNew) => {
    if (state?.viewOnly) {
      return false
    }
    if (userRole === ROLES.ItAdmin) {
      return true
    }
    if (
      userRole === ROLES.RegistrationScruitnizer &&
      state?.userType === "Internal"
    ) { return true; }
    else if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
      return true
    }
    else if (isNew) {
      return true
    }
    else return false
  }

  const getSubmit = () => {
    if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
      return true
    }
    else {
      return false
    }
  }

  const [personalRevenueCircleAndBlockList, setPersonalRevenueCircleAndBlockList] = useState([personalRevenueCircleBlocklistLabel === REVENUE_CIRCLE ? lleDetails?.lleMasters[0]?.revenueCircle : lleDetails?.lleMasters[0]?.blockName]);

  const onClickVerifyMobileNo = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, OTPError: "" });
    setOtpValue("");
    if (isValidMobileNumber(mobileNumber)) {
      sendOTP(mobileNumber, callBackMobileValidation);
      setErrorMessage({ ...errorMessage, mobileNoError: "" });
    }
    else
      setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
  }

  const callBackMobileValidation = (response) => {
    setErrorMessage({ ...errorMessage, mobileNoError: "" });
    if (response.isSuccess) {
      setErrorMessage({ ...errorMessage, OTPSentError: "" })
      setErrorMessage({ ...errorMessage, mobileNoError: "" });
      setVerifyMobileNo(true);
      setOtpHidden(false);
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }

  }

  const onOtpChange = (e) => {
    const limit = 6;
    setOtpValue(e.target.value.slice(0, limit))
    if (e.target.value.length == 6) {
      validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
    }
  }

  const callBackOTPValidation = (response) => {
    setErrorMessage({ ...errorMessage, OTPSentError: "" });
    setErrorMessage({ ...errorMessage, mobileNoError: "" });
    if (response.isSuccess === true) {
      setVerifyMobileNo(false);
      setOtpHidden(true);
      setMobileOTPValidated(true);
      setErrorMessage({ ...errorMessage, OTPError: "" });
      setErrorMessage({ ...errorMessage, mobileNoError: "" });
    }
    else {
      setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
    }
  }

  const isValidMobileNumber = (mobileNo) => {
    if (mobileNo.length == 10) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (district) {
      loaderService.showLoader();
      apiClient.post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
        {
          "district": district,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
        .then((response) => {
          if (states === "ASSAM") {
            setPersonalRevenueCircleBlocklistLabel(REVENUE_CIRCLE)
            setPersonalRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.revenueCircleLists)
            if (response.data.revenueCircleAndBlockList.revenueCircleLists.length > 0) {
              // setUpdatedDetails({ ...details, revenueCircle: response.data.revenueCircleAndBlockList.revenueCircleLists[0], blockName: "" })
              setRevenueCircle(lleDetails.lleMasters[0].revenueCircle)
              setBlockLists('');
            } else {
              setRevenueCircle('');
              setBlockLists('');
            }
            // setUpdatedDetails({ ...details, revenueCircle: '', blockName: '' })
          } else {
            setPersonalRevenueCircleBlocklistLabel(BLOCK_LIST)
            setPersonalRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.blockLists)
            if (response.data.revenueCircleAndBlockList.blockLists.length > 0) {
              // setUpdatedDetails({ ...details, blockName: response.data.revenueCircleAndBlockList.blockLists[0], revenueCircle: "" })
              setRevenueCircle('')
              setBlockLists(lleDetails.lleMasters[0].blockName);
            } else {
              // setUpdatedDetails({ ...details, blockName: '', revenueCircle: "" })
              setRevenueCircle('');
              setBlockLists('');
            }
          }
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();
        });

    }
  }, [district]);

  // useEffect(() => {
  //   if (chippingDistrict) {
  //     loaderService.showLoader();
  //     apiClient.post(GET_ALL_BLOCKLIST_AND_REVENUECIRCLE,
  //       {
  //         "district": chippingDistrict,
  //       },
  //       {
  //         headers: {
  //           AuthKey: authKey,
  //         },
  //       }
  //     )
  //       .then((response) => {
  //         if (chippingState === "ASSAM") {
  //           setchippingRevenueCircleBlocklistLabel(REVENUE_CIRCLE)
  //           setchippingRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.revenueCircleLists)
  //           if (response.data.revenueCircleAndBlockList.revenueCircleLists.length > 0) {
  //             setChippingRevenueCircle(lleDetails.lleMasters[0].chippingUnitRevenueCircle);
  //             setChippingBlocklists('');
  //           } else {
  //             setChippingRevenueCircle('');
  //             setChippingBlocklists('');
  //           }

  //         } else {
  //           setchippingRevenueCircleBlocklistLabel(BLOCK_LIST)
  //           setchippingRevenueCircleAndBlockList(response.data.revenueCircleAndBlockList.blockLists)
  //           if (response.data.revenueCircleAndBlockList.blockLists.length > 0) {
  //             setChippingRevenueCircle('');
  //             setChippingBlocklists(lleDetails.lleMasters[0].chippingUnitBlockName);

  //           } else {
  //             setChippingRevenueCircle('');
  //             setChippingBlocklists('');
  //           }
  //         }

  //         loaderService.hideLoader();
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //         loaderService.hideLoader();
  //       });

  //   }
  // }, [chippingDistrict]);

  useEffect(() => {
    setStates(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.state : states)
    setDistrict(pincodeAddressDetails?.addresses[0] ? pincodeAddressDetails?.addresses[0]?.district : district)

  }, [pincodeAddressDetails]);

  // useEffect(() => {
  //   setChippingState(chippingPincodeDetails?.addresses[0] ? chippingPincodeDetails?.addresses[0]?.state : chippingState)
  //   setChippingDistrict(chippingPincodeDetails?.addresses[0] ? chippingPincodeDetails?.addresses[0]?.district : chippingDistrict)
  // }, [chippingPincodeDetails]);

  const onRadioButtonClick = (e) => {
    setLandType(e.target.value)
    if (e.target.name === "Owned_type") {
      if (e.target.value === "Owned") {
        setOwnedLabel(true);
        setLeasedLabel(false);
      }
      else if (e.target.value === "Leased") {
        setOwnedLabel(false);
        setLeasedLabel(true);
      }

    }

  }

  function getBankDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_ADDRESS_BY_IFSC,
        {
          "ifsc": ifscCode,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          setBankDetails(response.data);
          setErrorMessage({ ...errorMessage, ifscCodeError: "" });
        }
        else {
          setIfscCode("");
          setBranchName("");

        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  }

  const onApplicantClick = (e) => {
    setUpdatedDetails({ ...updatedDetails, applicantType: e.target.value });
    setApplicantType(e.target.value)
    if (e.target.value == "Individual" && (govIDType == "MOA" || govIDType == "Other")) {
      setGovIDType("Aadhaar ID")
      setGovIDNumber('')
    }
    if (e.target.value != "Individual" && govIDType == "Aadhaar ID") {
      setGovIDType("MOA")
    }
  }

  const onFullNameChange = (e) => {
    e.preventDefault();
    setFullName(e.target.value.slice(0, 100))

  }

  const handleChange = (e) => {

    // if (e.target.name === "name") {

    //   // 1) Clean + limit:

    //   const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "").slice(0, 100);

    //   // 2) Save cleaned value only once:

    //   setDetails({

    //     ...details,

    //     [e.target.name]: cleanedValue

    //   });

    //   // 3) Validate cleaned value:

    //   if (cleanedValue.length > 0) {

    //     const Fullname_regex = /^[a-zA-Z0-9/& ]+$/;

    //     if (!Fullname_regex.test(cleanedValue)) {

    //       setErrorMessage({

    //         ...errorMessage,

    //         fullNameError: "Please provide valid Name"

    //       });

    //     } else {

    //       setErrorMessage({

    //         ...errorMessage,

    //         fullNameError: ""

    //       });

    //     }

    //   } else {

    //     setErrorMessage({

    //       ...errorMessage,

    //       fullNameError: "Please enter Name of Applicant"

    //     });

    //   }

    // } else {

    //   // For other fields, normal update:

    //   setDetails({

    //     ...details,

    //     [e.target.name]: e.target.value

    //   });

    // }


    if (e.target.name === "address") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, addressError: "" })
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) });
      } else {
        setErrorMessage({ ...errorMessage, addressError: "Please enter Address" })

      }
    }
    if (e.target.name === "residenceProof") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, residenceProofError: "" })
      } else {
        setErrorMessage({ ...errorMessage, residenceProofError: "Please enter Residence Proof" })

      }
    }
    if (e.target.name === "registrationNo") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, registrationNoError: "" })
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)) });
      } else {
        setErrorMessage({ ...errorMessage, registrationNoError: "Please enter Registration/Incorporation No." })

      }
    }
    if (e.target.name === "educationQualification") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, educationQualificationError: "" })
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, 50)) });
      } else {
        setErrorMessage({ ...errorMessage, educationQualificationError: "Please enter Highest Educational Qualification" })

      }
    }
    if (e.target.name === "netWorth") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, netWorthError: "" })
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value.slice(0, 10) });
      } else {
        setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" })

      }
    }
    if (e.target.name === "workingCapital") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, workingCapitalError: "" })
        setUpdatedDetails({ ...updatedDetails, [e.target.name]: e.target.value.slice(0, 10) });
      } else {
        setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" })

      }
    }
    if (e.target.name === "typeOfOcc") {
      if ((e.target.value).length > 0) {
        setErrorMessage({ ...errorMessage, typeOfOccError: "" })
      } else {
        setErrorMessage({ ...errorMessage, typeOfOccError: "Please enter Type of Business/Occupation" })

      }
    }

    if (e.target.name === "emailId") {
      setEmailId(e.target.value.slice(0, 50));
      if ((e.target.value).length > 0) {
        if (isValidEmail(e.target.value)) {
          setErrorMessage({ ...errorMessage, emailIdError: "" })
        } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid email" })
      } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
    }
    if (e.target.name === "contactPersonFirstName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value.slice(0, 50).replace(/[^a-z]/gi, '') })
      if ((e.target.value).length > 0) {
        const Firstname_regex = /^[a-zA-Z]+$/;
        if (!((e.target.value).match(Firstname_regex))) {
          setErrorMessage({ ...errorMessage, contactPersonNameError: "Please provide valid Name" })
        } else setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
      } else {
        setErrorMessage({ ...errorMessage, contactPersonNameError: "Please enter First Name of contact person" })

      }
    }
    if (e.target.name === "contactPersonMiddleName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value.slice(0, 50).replace(/[^a-z]/gi, '') })
      const Middlename_regex = /^[a-zA-Z]+$|^$/;
      if (!((e.target.value).match(Middlename_regex))) {
        setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "Please provide valid Name" })
      }
      else {
        setErrorMessage({ ...errorMessage, contactPersonMiddleNameError: "" })
      }

    }
    if (e.target.name === "contactPersonLastName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value.slice(0, 50).replace(/[^a-z]/gi, '') })
      const Lastname_regex = /^[a-zA-Z]+$|^$/;
      if (!((e.target.value).match(Lastname_regex))) {
        setErrorMessage({ ...errorMessage, contactPersonLastNameError: "Please provide valid Name" })
      }
      else {
        setErrorMessage({ ...errorMessage, contactPersonLastNameError: "" })
      }

    }
    if (e.target.name === "mobileNo") {
      const limit = 10;
      setMobileNumber(e.target.value.slice(0, mobileNoMaxLength))
      if ((e.target.value).length < 10) {
        setErrorMessage({ ...errorMessage, mobileNoError: "Please enter 10 digit mobile number" });
      }
      else setErrorMessage({ ...errorMessage, mobileNoError: "" });

    }
    if (e.target.name === "pincode") {
      const limit = 6;
      setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
      if ((e.target.value).length < 6) {
        setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
      }
      else setErrorMessage({ ...errorMessage, pincodeError: "" });
    }
  };

  useEffect(() => {
    if (bankDetails) {
      setBranchName(bankDetails?.branch)
      setBankName(bankDetails?.bank)
    }
  }, [bankDetails]);

  const onDaytimePowerAvailabilityChange = (e) => {
    setDaytimePowerAvailability(e.target.value)
  }
  const optedLocationPowerConnectionDistanceChnage = (e) => {
    setOptedLocationPowerConnectionDistance(e.target.value)
  }
  const roadConnectivityChange = (e) => {
    setRoadConnectivity(e.target.value)
  }
  const landAvailabilityOnChange = (e) => {
    setLandAvailability(e.target.value)
  }

  const onApplicantAddressRangeChange = (e) => {
    setApplicantAddressRangeFromOperationArea(e.target.value)
  }
  const onMobileChange = (e) => {
    e.preventDefault();
    setMobileNumber(e.target.value)

  }
  const onPanNumberChange = (e) => {
    e.preventDefault();
    setPanNumber(e.target.value.slice(0, 10).replace(/[^a-zA-Z0-9]/gi, ''));
    if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value)) {
      setErrorMessage({ ...errorMessage, panNumberError: "" })
      setPanNumber(e.target.value);
    } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
  }

  const onLabourLicenseNoChange = (e) => {
    e.preventDefault();
    setLabourLicenseNo(VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 20)))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, labourLicenseNoError: "" })
    }
  }

  const onLabourLicenseEndDateChange = (e) => {
    // e.preventDefault();
    let selectedDate = e.format(BASIC_DATE_FORMAT)
    let formattedDate = e.format(API_DATE_FORMAT)
    setLabourLicenseEndDateDisplay(selectedDate)
    setLabourLicenseEndDate(formattedDate)
  }

  const onTradeLicenseNoChange = (e) => {
    e.preventDefault();
    setTradeLicenseNo(VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 20)))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, tradeLicenseNoError: "" })
    }
  }

  const onTradeLicenseEndDateChange = (e) => {
    let selectedDate = e.format(BASIC_DATE_FORMAT)
    let formattedDate = e.format(API_DATE_FORMAT)
    setTradeLicenseEndDateDisplay(selectedDate)
    setTradeLicenseEndDate(formattedDate)

  }
  const onGovIdypeChange = (e) => {
    e.preventDefault();
    if (e.target.name === "govtIdCardType") {
      setGovIDType(e.target.value);
    }
    else if (e.target.name === 'otherGovtCardType') {
      const limit = 50;
      if (e.target.value.length > 0) {
        setOtherIdType(VALIDATION.fullNameValidation(e.target.value).slice(0, limit));
        setErrorMessage({ ...errorMessage, otherCardError: '' })
      }
      else {
        setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
      }
    }
    else if (e.target.value === "Aadhaar ID") {
      setGovIDNumberVisible(true)
    } else {
      setGovIDNumberVisible(false)
    }
  }
  const onClickAadharChange = (e) => {
    const limit = 4;
    const idlimit = (govIDType === "Registration Certificate" || govIDType === "MOA") ? 30 : 20
    if (govIDType === "Aadhaar ID") {
      setGovIDNumber(e.target.value.replace(/[^0-9]/gi, '').slice(0, limit))
    }
    else {
      setGovIDNumber(e.target.value.toUpperCase().slice(0, idlimit))
    }
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, govtIdCardNumberError: '' })
    }

  }

  const onEmailChange = (e) => {
    setEmailId(e.target.value.slice(0, 50))
    if ((e.target.value).length > 0) {
      if (emailValidation(e.target.value)) {
        setErrorMessage({ ...errorMessage, emailIdError: "" })
      } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
    }
  }

  const onLandAreaChange = (e) => {
    if (e.target.name === "landAreaValue") {
      var slicedLandArea = landAreaValidation(e.target.value);
      setLandAreaValue(slicedLandArea);
      if (slicedLandArea.length == 0) {
        setErrorMessage({ ...errorMessage, landAreaError: "Please enter Land Area" });
      }
      else setErrorMessage({ ...errorMessage, landAreaError: "" });
      setUpdatedDetails({ ...updatedDetails, "landArea": slicedLandArea + ' ' + landAreaUnit });
    }
    if (e.target.name === "landAreaUnit") {
      setLandAreaUnit(e.target.value);
      setUpdatedDetails({ ...updatedDetails, "landArea": landAreaValue + ' ' + e.target.value });
    }
  }
  const onContactPersonDetailChange = (e) => {
    e.preventDefault();
    setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: e.target.value });
    if (e.target.name === "contactPersonFirstName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
        setErrorMessage({ ...errorMessage, contactPersonFirstNameError: '' })
      }
    }
    if (e.target.name === "contactPersonMiddleName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      } else return
    }
    if (e.target.name === "contactPersonLastName") {
      setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0) {
        setContactPersonDetails({ ...contactPersonDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      } else return
    }
  }
  const onAddressChange = (e) => {
    setAddress(e.target.value)
    if (e.target.name === "address") {
      if ((e.target.value).length > 0) {
        setAddress(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)))
        setErrorMessage({ ...errorMessage, addressError: "" })
      } else setErrorMessage({ ...errorMessage, addressError: "Please enter valid address" })
    }
  }
  const handleChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setBlockLists(e.target.value);
    }
    if (type == REVENUE_CIRCLE) {
      setRevenueCircle(e.target.value);
    }
  }
  const handleChippingChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setChippingBlocklists(e.target.value);
    }
    if (type == REVENUE_CIRCLE) {
      setChippingRevenueCircle(e.target.value);
    }
  }
  const onChippingAddressChange = (e) => {
    e.preventDefault();
    setChippingAddress(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)))
    if ((e.target.value).length > 0) {
      setChippingAddress(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)))
      setErrorMessage({ ...errorMessage, chippingaddressError: "" })
    }
  }
  const existingOccupationChange = (e) => {
    e.preventDefault();
    setExistingOccupation(e.target.value)
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, typeOfOccError: "" })
    }
  }
  const educationQualificationChange = (e) => {
    e.preventDefault();
    setEducationQualification(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, educationQualificationError: "" })
    }
  }

  const onLocationPoint = (position) => {
    setLatitude(position?.coords?.latitude ? position?.coords?.latitude : position.Latitude);
    setLongitude(position?.coords?.longitude ? position?.coords?.longitude : position.Longitude);
  }

  const registrationNoChange = (e) => {
    e.preventDefault();
    setRegistrationNo(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 50)))
  }
  const onNetWorthChange = (e) => {
    const limit = 10;
    e.preventDefault();
    setNetWorth(e.target.value.slice(0, limit))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, netWorthError: "" })
    }
  }
  const onWorkingCapitalChange = (e) => {
    const limit = 10;
    e.preventDefault();
    setWorkingCapital(e.target.value.slice(0, limit))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, workingCapitalError: "" })
    }
  }
  const onQuantityhandleChange = (e) => {
    const limit = 6;
    e.preventDefault();
    setQuantitylle(e.target.value.slice(0, limit))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, quantitylleError: "" })
    }
  }
  const OnLandAreahandleChange = (e) => {
    const limit = 6;
    e.preventDefault();
    setLandArealle(e.target.value.slice(0, limit))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, landArealleError: "" })
    } else setErrorMessage({ ...errorMessage, landArealleError: 'Please enter land Area' })
  }
  const onUploadCallBack = (docArray) => {
    setDocumentArray(docArray);

  }
  const onbankAccountNumberChange = (e) => {

    e.preventDefault();
    const limit = 18;
    setAccountNumber(e.target.value.slice(0, limit))
    if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
      setErrorMessage({ ...errorMessage, bankAccountNumberError: "" })
      setAccountNumber(e.target.value.slice(0, limit))
    } else setErrorMessage({ ...errorMessage, bankAccountNumberError: 'Please enter valid Account Number' })
  }

  const onbankAccountHolderNameChange = (e) => {

    e.preventDefault();
    if (e.target.name === "bankAccountHolderName") {

      setAccountHolderName(VALIDATION.fullNameValidation(e.target.value))
      if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
        setErrorMessage({ ...errorMessage, bankAccountHolderNameError: "" })
      }
      else {
        setErrorMessage({ ...errorMessage, bankAccountHolderNameError: "Please enter Account Holder's Name" })

      }
    }
  }
  const onbankIfscChange = (e) => {

    e.preventDefault();
    setIfscCode(e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '').slice(0, 11));
    if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
      setErrorMessage({ ...errorMessage, ifscCodeError: "" })
      setBranchName('');
    } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
  }

  const onGstNoChange = (e) => {
    e.preventDefault();
    const value = e.target.value.toUpperCase().slice(0, 20); // <-- LIMIT HERE
    setGstNo(value);
    if (value.length > 0 && VALIDATION.gstNumberValidation(value)) {
      setErrorMessage({ ...errorMessage, gstNoError: "" });
    } else {
      setErrorMessage({ ...errorMessage, gstNoError: "Please enter valid GST No" });
    }
  };
  const onNonEncumbranceCertificateNoChange = (e) => {
    e.preventDefault();
    setNonEncumbranceCertificateNo(VALIDATION.noSpecialCharCapsValidation(e.target.value.slice(0, 20)))
    if ((e.target.value).length > 0) {
      setErrorMessage({ ...errorMessage, nonEncumbranceCertificateNoError: "" })
    }
  }
  const onAgreementStartDateChange = (e) => {
    let selectedDate = e.format(BASIC_DATE_FORMAT)
    let formattedDate = e.format(API_DATE_FORMAT)
    setAgreementStartDateDisplay(selectedDate)
    setAgreementStartDate(formattedDate)
    if (checkDateValidation(selectedDate, agreementEndDateDisplay)) {
      setErrorMessage({ ...errorMessage, agreementDateError: DATE_RANGE_ERROR })
    } else setErrorMessage({ ...errorMessage, agreementDateError: '' })
  }

  const onAgreementEndDateChange = (e) => {
    let selectedDate = e.format(BASIC_DATE_FORMAT)
    let formattedDate = e.format(API_DATE_FORMAT)
    setAgreementEndDateDisplay(selectedDate)
    setAgreementEndDate(formattedDate)
    if (checkDateValidation(agreementStartDateDisplay, selectedDate)) {
      setErrorMessage({ ...errorMessage, agreementDateError: DATE_RANGE_ERROR })
    } else setErrorMessage({ ...errorMessage, agreementDateError: '' })

  }
  const getUpdatedAddressData = (data) => {
    setPincode(data.pincode);
    setStates(data.pincodeState);
    setDistrict(data.pincodeDistrict);
    setRevenueCircle(data.selectedRevenueCircle);
    setBlockLists(data.selectedBlockName);
    setErrorMessage({ ...errorMessage, pincodeError: "" })
  }
  const getUpdatedChippingAddressData = (data) => {
    setChippingPincode(data.pincode);
    setChippingState(data.pincodeState);
    setChippingDistrict(data.pincodeDistrict);
    setChippingRevenueCircle(data.selectedRevenueCircle);
    setChippingBlocklists(data.selectedBlockName);
    setErrorMessage({ ...errorMessage, chippingpincodeError: "" })
  }

  const checkValidations1 = () => {
    if (applicantType !== 'Individual' && isMSMERadio === 'YES') {

      if (!msmeCategory) {
        toast.error("Please select MSME category");
        setExpandedSection("personal");
        return;
      }

      const msmeDoc =
        documentArray &&
        documentArray.filter(
          (item) =>
            item.documentType === "MSME_Certificate" &&
            (item.isActive === 1 || item.isActive === 3)
        );

      if (!msmeDoc || msmeDoc.length === 0) {
        setErrorMessage({
          ...errorMessage,
          msmeDocError: "Please upload MSME certificate"
        });
        toast.error("Please upload MSME certificate");
        setExpandedSection("personal");
        return;
      }
    }
    else if (!contactPersonDetails.contactPersonFirstName || contactPersonDetails.contactPersonFirstName?.length == 0) {
      setErrorMessage({ ...errorMessage, contactPersonFirstNameError: "Please enter Contact Person First Name" });
      toast.error("Please enter Contact Person First Name");
      setExpandedSection("personal");
      return;
    }
    else if (!mobileNumber || mobileNumber?.length == 0) {
      setErrorMessage({ ...errorMessage, mobileNoError: "Please enter mobile number" });
      toast.error("Please enter mobile number");
      setExpandedSection("personal");
      return;
    }
    else if (!emailId || emailId?.length == 0 || !emailValidation(emailId)) {
      setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" });
      toast.error("Please enter valid Email Address");
      setExpandedSection("personal");
      return;
    }
    else if (!address || address?.length == 0) {
      toast.error("Please enter Address");
      setErrorMessage({ ...errorMessage, addressError: "Please enter Address" });
      setExpandedSection("personal");
      return;
    }
    else if (!pincode || pincode?.length !== 6) {
      toast.error("Please enter 6 digit pincode");
      setErrorMessage({ ...errorMessage, pincodeError: "Please enter 6 digit pincode" });
      setExpandedSection("personal");
      return;
    }
    else if (userRole !== ROLES.ItAdmin) {
      if (govIDType == "Other" && !otherIdType) {
        toast.error("Please enter ID Proof Name");
        setErrorMessage({ ...errorMessage, otherCardError: "Please enter ID Proof Name" });
        setExpandedSection("personal");
        return;
      }
      if (!govIDNumber || govIDNumber?.length == 0) {
        toast.error("Please enter Address Proof ID");
        setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please enter Address Proof ID" });
        setExpandedSection("personal");
        return;
      }
      else if (panNumber && panNumber.length > 0) {
        if (!VALIDATION.panNumberValidation(panNumber)) {
          toast.error("Please enter valid PAN Number");
          setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
          setExpandedSection("personal");
          return;
        }
      }
      var addressDoc = documentArray && documentArray.filter((item) => item.documentType === ID_PROOF && (item.isActive == 1 || item.isActive == 3));
      if (addressDoc.length == 0) {
        toast.error("Please upload address proof document");
        setErrorMessage({ ...errorMessage, idProofDocError: "Please upload address proof document" });
        setExpandedSection("personal");
        return;
      }
    }
    checkValidations2();
  }

  const checkValidations2 = () => {
    if (userRole !== ROLES.ItAdmin) {
      if (!accountNumber || accountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(accountNumber)) {
        setErrorMessage({ bankAccountNumberError: "Please enter valid Account Number" });
        toast.error("Please enter valid Account Number");
        setExpandedSection("bank");
        return;
      }
      else if (!accountHolderName || accountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(accountHolderName)) {
        setErrorMessage({ bankAccountHolderNameError: "Please enter Account Holder's Name" });
        toast.error("Please enter Account Holder's Name");
        setExpandedSection("bank");
        return;
      }
      else if (!ifscCode || ifscCode.length == 0 || !VALIDATION.ifscValidation(ifscCode)) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC Code" });
        toast.error("Please enter valid IFSC Code");
        setExpandedSection("bank");
        return;
      }
      else if (!branchName || branchName.length == 0) {
        setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" });
        toast.error("Please enter valid IFSC code and search");
        setExpandedSection("bank");
        return;
      }
      var bankdoc = documentArray && documentArray.filter((item) => item.documentType === BANK_CANCELLED_CHEQUE && (item.isActive == 1 || item.isActive == 3));
      if (bankdoc.length == 0) {
        setErrorMessage({ bankDocError: "Please upload bank document" });
        toast.error("Please upload bank document");
        setExpandedSection("bank");
        return;
      }
    }
    checkValidations3();
  }

  const checkValidations3 = () => {
    var qualificationDOC = documentArray && documentArray.filter((item) => item.documentType === HIGHEST_QUALIFICATION && (item.isActive == 1 || item.isActive == 3));
    var registrationDOC = documentArray && documentArray.filter((item) => item.documentType === MOA_REGISTRATION_CERTIFICATE && (item.isActive == 1 || item.isActive == 3));
    var valuationDoc = documentArray && documentArray.filter((item) => item.documentType === VALATION_REPORT && (item.isActive == 1 || item.isActive == 3));
    var occDoc = documentArray && documentArray.filter((item) => item.documentType === EXISTING_OCC && (item.isActive == 1 || item.isActive == 3));

    if (applicantType === 'Individual' && !educationQualification || educationQualification?.length == 0) {
      setErrorMessage({ ...errorMessage, educationQualificationError: "Please enter Educational Qualification" });
      toast.error("Please enter Educational Qualification");
      setExpandedSection("qualification");
      return;
    }
    else if (applicantType === 'Individual' && qualificationDOC?.length == 0) {
      setErrorMessage({ ...errorMessage, highestQualiDocError: "Please upload educational qualification document." });
      toast.error("Please upload educational qualification document");
      setExpandedSection("qualification");
      return;
    }
    else if (applicantType !== 'Individual' && !registrationNo || registrationNo?.length == 0) {
      toast.error("Please enter Registration No");
      setErrorMessage({
        ...errorMessage, registrationNoError: "Please enter Registration No"
      });
      setExpandedSection("qualification");
      return;
    }
    else if (applicantType !== 'Individual' && registrationDOC?.length == 0) {
      setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "Please upload registration document." });
      toast.error("Please upload registration document");
      setExpandedSection("qualification");
      return;
    }
    else if (!existingOccupation || existingOccupation.length == 0) {
      toast.error("Please enter Type of Business/Occupation");
      setErrorMessage({ ...errorMessage, typeOfOccError: "Please enter Type of Business/Occupation" });
      setExpandedSection("qualification");
      return;
    }
    else if (occDoc.length == 0) {
      setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: "Please upload business/occupation certificate" });
      toast.error("Please upload business/occupation certificate");
      setExpandedSection("qualification");
      return;
    }
    else if (valuationDoc.length == 0) {
      setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: " ", valuationDocError: "Please upload valuation report" });
      toast.error("Please upload valuation report");
      setExpandedSection("qualification");
      return;
    }
    else if (!netWorth || netWorth?.length <= 0) {
      toast.error("Please enter Net Worth");
      setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" });
      setExpandedSection("qualification");
      return;
    }
    else if (!workingCapital || workingCapital?.length <= 0) {
      toast.error("Please enter Working Capital");
      setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" });
      setExpandedSection("qualification");
      return;
    }
    else if (userRole !== ROLES.ItAdmin) {
      //if (!tradeLicenseNo || tradeLicenseNo.length == 0) {
      //  setErrorMessage({ ...errorMessage, tradeLicenseNoError: "Please enter Trade License No " });
      //  return;
      //}
      //else if (!tradeLicenseEndDate || tradeLicenseEndDate.length == 0) {
      //  setErrorMessage({ ...errorMessage, tradeLicenseNoError: "Please enter Trade License End Date " });
      //  return;
      //}
      //else if (!labourLicenseNo || labourLicenseNo.length == 0) {
      //  setErrorMessage({ ...errorMessage, labourLicenseNoError: "Please enter Labour License No  " });
      //  return;
      //}
      //else if (!labourLicenseEndDate || labourLicenseEndDate.length == 0) {
      //  setErrorMessage({ ...errorMessage, labourLicenseNoError: "Please enter Labour License End Date  " });
      //  return;
      //}
      //else if (!gstNo || gstNo.length == 0 || !VALIDATION.gstNumberValidation(gstNo)) {
      //  setErrorMessage({ ...errorMessage, gstNoError: "Please enter valid GST No " });
      //  return;
      //}


      // if (!nonEncumbranceCertificateNo || nonEncumbranceCertificateNo.length == 0) {
      //     setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: " ", valuationDocError: " " , nonEncumbranceCertificateNoError: "Please enter Non-Encumbrance CertificateNo  " });
      //   return;
      //}  
      // else {
      //     setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: " ", valuationDocError: " " , nonEncumbranceCertificateNoError: " " });
      // }
      //var tradeLicDoc = documentArray && documentArray.filter((item) => item.documentType === LLE_TRADE_LICENSE && item.isActive == 1);
      //if (tradeLicDoc.length == 0) {
      //  setErrorMessage({ ...errorMessage, tradeLicenseDocError: "Please upload trade license document" });
      //  return;
      //}
      //var labourLicDoc = documentArray && documentArray.filter((item) => item.documentType === LABOUR_LICENCE && item.isActive == 1);
      //if (labourLicDoc.length == 0) {
      //  setErrorMessage({ ...errorMessage, labourLicenseDocError: "Please upload labour license document" });
      //  return;
      //}
      //var gstDoc = documentArray && documentArray.filter((item) => item.documentType === GST && item.isActive == 1);
      //if (gstDoc.length == 0) {
      //  setErrorMessage({ ...errorMessage, gstDocError: "Please upload gst document" });
      //  return;
      //}
      //var nonEncumDoc = documentArray && documentArray.filter((item) => item.documentType === NON_ENCUMBRANCE_CERTI && item.isActive == 1);
      //   if (nonEncumDoc.length == 0) {
      //       setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: " ", valuationDocError: " " , nonEncumDocError: "Please upload non-encumbrance certificate" });
      //       return;
      //   }
      //   else {
      //       setErrorMessage({ ...errorMessage, highestQualiDocError: "", regCertDocError: "", existingOCCDocError: " ", valuationDocError: " " , nonEncumDocError: " " });
      //   }
    }
    checkValidations4();
  }

  const checkValidations4 = () => {
    var landdoc = documentArray && documentArray.filter((item) => item.documentType === GEOCODE_LOCATION && (item.isActive == 1 || item.isActive == 3));
    if (!chippingAddress || chippingAddress?.length == 0) {
      setErrorMessage({ chippingaddressError: "Please enter Address" });
      toast.error("Please enter Address");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!chippingPincode || chippingPincode?.length != 6) {
      setErrorMessage({ chippingpincodeError: "Please enter 6 digit Pincode" });
      toast.error("Please enter 6 digit Pincode");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!latitude || latitude.length == 0 || !VALIDATION.latitudeLongitudeValidation(latitude)) {
      setErrorMessage({ latitudesError: "Please enter valid Latitude" });
      toast.error("Please enter valid Latitude");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!longitude || longitude.length == 0 || !VALIDATION.latitudeLongitudeValidation(longitude)) {
      setErrorMessage({ longitudesError: "Please enter valid Longitude" });
      toast.error("Please enter valid Longitude");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!landAreaValue || landAreaValue.length == 0) {
      setErrorMessage({ landAreaError: "Please enter land area" });
      toast.error("Please enter land area");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!quantitylle || quantitylle?.length == 0) {
      setErrorMessage({ quantitylleError: "Please enter Quantity" });
      toast.error("Please enter Quantity");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (!landArealle || landArealle?.length == 0) {
      setErrorMessage({ landArealleError: "Please enter Land Area" });
      toast.error("Please enter Land Area");
      setExpandedSection("chippingLocation");
      return;
    }
    else if (userRole !== ROLES.ItAdmin) {
      if (landdoc.length == 0) {
        setErrorMessage({ landPicError: "Please upload land image" });
        toast.error("Please upload land image");
        setExpandedSection("chippingLocation");
        return;
      }
    }
    checkValidations5();
  }
  const checkValidations5 = () => {
    if (userRole !== ROLES.ItAdmin) {
      var addressProofdoc = documentArray && documentArray.filter((item) => item.documentType === APPLICATION_ADDRESS_EVIDENCE && (item.isActive == 1 || item.isActive == 3));
      if (addressProofdoc.length == 0) {
        setErrorMessage({ addressProofDocError: "Please upload proof of residence" });
        toast.error("Please upload proof of residence");
        setExpandedSection("location");
        return;
      }
      var landdoc = documentArray && documentArray.filter((item) => item.documentType === LAND_DOCUMENT && (item.isActive == 1 || item.isActive == 3));
      if (landdoc.length == 0) {
        setErrorMessage({ landDocError: "Please upload Jamabandi/Khajana or Tax paid receipt" });
        toast.error("Please upload Jamabandi/Khajana or Tax paid receipt");
        setExpandedSection("location");
        return;
      }
    }
    checkValidations6();
  }

  const checkValidations6 = () => {
    if (userRole !== ROLES.ItAdmin) {
      var roadpic = documentArray && documentArray.filter((item) => item.documentType === ROAD_PHOTO && (item.isActive == 1 || item.isActive == 3));
      if (roadpic.length == 0) {
        setErrorMessage({ roadPicError: "Please upload road picture" });
        toast.error("Please upload road picture");
        setExpandedSection("location");
        return;
      }
    }
    showPreview();
  }

  const getRegistrationStatus = (submit) => {
    var regStatus = lleDetails?.registrationStatus;
    if (userRole != ROLES.ItAdmin) {
      if (lleDetails?.registrationStatus === "Approved" && userRole === RESOURCE_ROLES.PlantSCMMember || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal")) {
        regStatus = "ResourceUpdate_Initiated";
      }
    }
    return regStatus;
  }

  // const saveAndExitClickPreview = () => {
  //   const dataForAPi = {
  //     "id": id,
  //     "name": fullName,
  //     "contactPersonName": contactPersonDetails.contactPersonFirstName,
  //     "contactPersonFirstname": contactPersonDetails.contactPersonFirstName,
  //     "contactPersonMiddlename": contactPersonDetails.contactPersonMiddleName,
  //     "contactPersonLastname": contactPersonDetails.contactPersonLastName,
  //     "contactPersonGender": contactPersonDetails.contactPersonGender,
  //     "contactPersonSalutation": contactPersonDetails.contactPersonSalutation,
  //     "mobileNo": mobileNumber,
  //     "bankAccountNumber": accountNumber,
  //     "bankAccountHolderName": accountHolderName,
  //     "bankBranch": branchName,
  //     "bankIfscCode": ifscCode,
  //     "bankName": bankName,
  //     "panNumber": panNumber,
  //     "govtIdCardType": govIDType,
  //     "govtIdCardNumber": govIDNumber,
  //     "otherGovtCardType": otherIdType,
  //     "emailId": emailId,
  //     "category": lleDetails?.category,
  //     "urn": urn,
  //     "isOtpValidated": mobileOTPValidated === true ? true : false,
  //     "preregistrationShortlisted": lleDetails?.preregistrationShortlisted,
  //     "registrationStatus": getRegistrationStatus(),
  //     "scrutinyStatus": lleDetails?.scrutinyStatus,
  //     "stakeholderStatus": lleDetails?.stakeholderStatus,
  //     "createdOn": lleDetails?.createdOn,
  //     "createdBy": lleDetails?.createdBy,
  //     "updatedOn": lleDetails?.updatedOn,
  //     "updatedBy": lleDetails?.updatedBy,
  //     "isActive": 1,
  //      "acceptedTerms": lleDetails?.acceptedTerms,
  //     "lleDetail": {
  //       "id": lleDetails?.lleMasters[0]?.id,
  //       "regStakeholderMasterId": lleDetails?.lleMasters[0]?.regStakeholderMasterId,
  //       "pincode": pincode,
  //       "address": address,
  //       "state": states,
  //       "district": district,
  //       "revenueCircle": revenueCircle,
  //       "blockName": blockLists,
  //       "applicantType": lleDetails?.lleMasters[0]?.applicantType,
  //       "highestEducationalQualification": educationQualification,
  //       "registrationNumber": registrationNo,
  //       "netWorth": netWorth,
  //       "workingCapital": workingCapital,
  //       "existingOccupation": existingOccupation,
  //       "chippingUnitAddress": chippingAddress,
  //       "chippingUnitDistrict": chippingDistrict,
  //       "chippingUnitState": chippingState,
  //       "chippingUnitPincode": chippingPincode,
  //       "chippingUnitLatitude": latitude,
  //       "chippingUnitLongitude": longitude,
  //       "chippingUnitBlockName": chippingBlockLists,
  //       "chippingUnitRevenueCircle": chippingRevenueCircle,
  //       "estimatedBambooQuantity": quantitylle,
  //       "estimatedLandArea": landArealle,
  //       "isApplicantAddressInOperationArea": lleDetails.lleMasters[0].isApplicantAddressInOperationArea,
  //       "applicantAddressRangeFromOperationArea": applicantAddressRangeFromOperationArea,
  //       "isOptedLandValid": lleDetails.lleMasters[0].isOptedLandValid,
  //       "landAvailability": landAvailability,
  //       "landType": landType,
  //       "roadConnectivity": roadConnectivity,
  //       "isRoadConnectivityValid": lleDetails.lleMasters[0].isRoadConnectivityValid,
  //       "isDadicatedTransformerLoaded": lleDetails.lleMasters[0].isDadicatedTransformerLoaded,
  //       "optedLocationPowerConnectionDistance": optedLocationPowerConnectionDistance,
  //       "isAlternatePowerSupplyAvailable": lleDetails.lleMasters[0].isAlternatePowerSupplyAvailable,
  //       "daytimePowerAvailability": daytimePowerAvailability,
  //       "isApplicantArrangeOwnAmount6070Lacs": lleDetails.lleMasters[0].isApplicantArrangeOwnAmount6070Lacs,
  //       "isBankSupportNeddedThroughAbrpl": lleDetails.lleMasters[0].isBankSupportNeddedThroughAbrpl,
  //       "isStrongMobileNetworkConnectivity": lleDetails.lleMasters[0].isStrongMobileNetworkConnectivity,
  //       "isValidEnvironmentAndSustainability": lleDetails.lleMasters[0].isValidEnvironmentAndSustainability,
  //       "isLocationSociallyValid": lleDetails.lleMasters[0].isLocationSociallyValid,
  //       "labourLicenceNumber": labourLicenseNo,
  //       "labourLicenceEndDate": labourLicenseEndDate ? labourLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
  //       "tradeLicenceNumber": tradeLicenseNo,
  //       "tradeLicenceEndDate": tradeLicenseEndDate ? tradeLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
  //       "gstNumber": gstNo,
  //       "nonEncumbranceCertificateNo": nonEncumbranceCertificateNo,
  //       "agreementStartDate": agreementStartDate,
  //       "agreementEndDate": agreementEndDate,
  //       "locationGeotag": lleDetails.lleMasters[0].locationGeotag,
  //       "documentId": lleDetails.lleMasters[0].documentId,
  //       "isAgreedToEnvionmentHealthSafetyLawsRegulation": lleDetails.lleMasters[0].isAgreedToEnvionmentHealthSafetyLawsRegulation,
  //       "isAgreedToResourceSustanability": lleDetails.lleMasters[0].isAgreedToResourceSustanability,
  //       "isSelfCertified": lleDetails.lleMasters[0].isSelfCertified,
  //       "createdOn": lleDetails.lleMasters[0].createdOn,
  //       "createdBy": lleDetails.lleMasters[0].createdBy,
  //       "updatedOn": lleDetails.lleMasters[0].updatedOn,
  //       "updatedBy": lleDetails.lleMasters[0].updatedBy,
  //       "landArea": landAreaValue + " " + landAreaUnit,
  //       "isActive": 1,
  //       "documents": documentArray
  //     }
  //   }
  //   apiClient
  //     .post(UPDATE_LLE + `?IsRegistrationSubmit=${isRegistrationSubmit}`,
  //       dataForAPi,
  //       {
  //         headers: {
  //           Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
  //         }
  //       }
  //     )
  //     .then((response) => {
  //       // if(preview===true){
  //       //   setHidden({ ...hidden, divPreview: false })
  //       // }
  //       // else{
  //       //   navigate('/dashboardStakeHolder')
  //       // }
  //       setNextClick(nextClick + 1);
  //       setHidden({ ...hidden, divPreview: false })
  //     })
  //     .catch(function (error) {
  //     })
  // }

  const SubmitCallBack = (response) => {
    setApiResponse(response.data);
  }
  const SaveExitCallBack = (response) => {
    if (ResourceUpdateMember.includes(userRole) && userRole === ROLES.ItAdmin) {
      navigate("/sidebar/viewAllActiveApplications")
    }
    else if (ResourceUpdateMember.includes(userRole) && userRole === RESOURCE_ROLES.PlantSCMMember) {
      navigate("/resourcedashboard/searchByURN")
    }
    else navigate('/dashboardHome/dashboardStakeHolder')
  }
  useEffect(() => {
    if (apiResponse) {
      if (apiResponse.isSuccess === true) {
        toast.success("LLe updated successfully");
        if (ResourceUpdateMember.includes(userRole) && userRole === ROLES.ItAdmin) {
          navigate("/sidebar/viewAllActiveApplications")
        }
        else if (ResourceUpdateMember.includes(userRole) && userRole === RESOURCE_ROLES.PlantSCMMember) {
          navigate("/resourcedashboard/searchByURN")
        }
        else navigate('/dashboardHome/dashboardStakeHolder')
      } else {
        toast.error(apiResponse?.message);
      }
    }


  }, [apiResponse, apiError]);

  const initialData =
  {
    "id": lleDetails?.id,
    "name": lleDetails?.name,
    "contactPersonName": lleDetails?.contactPersonName,
    "contactPersonFirstname": lleDetails?.contactPersonFirstname,
    "contactPersonMiddlename": lleDetails?.contactPersonMiddlename,
    "contactPersonLastname": lleDetails?.contactPersonLastname,
    "contactPersonGender": lleDetails?.contactPersonGender,
    "contactPersonSalutation": lleDetails?.contactPersonSalutation,
    "mobileNo": lleDetails?.mobileNo,
    "bankAccountNumber": lleDetails?.bankAccountNumber,
    "bankAccountHolderName": lleDetails?.bankAccountHolderName,
    "bankBranch": lleDetails?.bankBranch,
    "bankIfscCode": lleDetails?.bankIfscCode,
    "bankName": lleDetails?.bankName,
    "panNumber": lleDetails?.panNumber,
    "govtIdCardType": lleDetails?.govtIdCardType,
    "govtIdCardNumber": lleDetails?.govtIdCardNumber,
    "otherGovtCardType": lleDetails?.otherGovtCardType,
    "emailId": lleDetails?.emailId,
    "category": lleDetails?.category,
    "urn": lleDetails?.urn,
    "isOtpValidated": lleDetails?.isOtpValidated,
    "preregistrationShortlisted": lleDetails?.preregistrationShortlisted,
    "registrationStatus": lleDetails?.registrationStatus,
    "scrutinyStatus": lleDetails?.scrutinyStatus,
    "stakeholderStatus": lleDetails?.stakeholderStatus,
    "createdOn": lleDetails?.createdOn,
    "createdBy": lleDetails?.createdBy,
    "updatedOn": lleDetails?.updatedOn,
    "updatedBy": lleDetails?.updatedBy,
    "isActive": lleDetails?.isActive,
    "lleDetail": {
      "id": lleDetails?.lleMasters[0]?.id,
      "regStakeholderMasterId": lleDetails?.lleMasters[0]?.regStakeholderMasterId,
      "pincode": lleDetails?.lleMasters[0]?.pincode,
      "address": lleDetails?.lleMasters[0]?.address,
      "state": lleDetails?.lleMasters[0]?.state,
      "district": lleDetails?.lleMasters[0]?.district,
      "revenueCircle": lleDetails?.lleMasters[0]?.revenueCircle,
      "blockName": lleDetails?.lleMasters[0]?.blockName,
      "applicantType": lleDetails?.lleMasters[0]?.applicantType,
      "highestEducationalQualification": lleDetails?.lleMasters[0]?.highestEducationalQualification,
      "registrationNumber": lleDetails?.lleMasters[0]?.registrationNumber,
      "netWorth": lleDetails?.lleMasters[0]?.netWorth,
      "workingCapital": lleDetails?.lleMasters[0]?.workingCapital,
      "existingOccupation": lleDetails?.lleMasters[0]?.existingOccupation,
      "chippingUnitAddress": lleDetails?.lleMasters[0]?.chippingUnitAddress,
      "chippingUnitDistrict": lleDetails?.lleMasters[0]?.chippingUnitDistrict,
      "chippingUnitState": lleDetails?.lleMasters[0]?.chippingUnitState,
      "chippingUnitPincode": lleDetails?.lleMasters[0]?.chippingUnitPincode,
      "chippingUnitLatitude": lleDetails?.lleMasters[0]?.chippingUnitLatitude,
      "chippingUnitLongitude": lleDetails?.lleMasters[0]?.chippingUnitLongitude,
      "chippingUnitBlockName": lleDetails?.lleMasters[0]?.chippingUnitBlockName,
      "chippingUnitRevenueCircle": lleDetails?.lleMasters[0]?.chippingUnitRevenueCircle,
      "estimatedBambooQuantity": lleDetails?.lleMasters[0]?.estimatedBambooQuantity,
      "estimatedLandArea": lleDetails?.lleMasters[0]?.estimatedLandArea,
      "isApplicantAddressInOperationArea": lleDetails?.lleMasters[0]?.isApplicantAddressInOperationArea,
      "applicantAddressRangeFromOperationArea": lleDetails?.lleMasters[0]?.applicantAddressRangeFromOperationArea,
      "isOptedLandValid": lleDetails?.lleMasters[0]?.isOptedLandValid,
      "landAvailability": lleDetails?.lleMasters[0]?.landAvailability,
      "landType": lleDetails?.lleMasters[0]?.landType,
      "roadConnectivity": lleDetails?.lleMasters[0]?.roadConnectivity,
      "isRoadConnectivityValid": lleDetails?.lleMasters[0]?.isRoadConnectivityValid,
      "isDadicatedTransformerLoaded": lleDetails?.lleMasters[0]?.isDadicatedTransformerLoaded,
      "optedLocationPowerConnectionDistance": lleDetails?.lleMasters[0]?.optedLocationPowerConnectionDistance,
      "isAlternatePowerSupplyAvailable": lleDetails?.lleMasters[0]?.isAlternatePowerSupplyAvailable,
      "daytimePowerAvailability": lleDetails?.lleMasters[0]?.daytimePowerAvailability,
      "isApplicantArrangeOwnAmount6070Lacs": lleDetails?.lleMasters[0]?.isApplicantArrangeOwnAmount6070Lacs,
      "isBankSupportNeddedThroughAbrpl": lleDetails?.lleMasters[0]?.isBankSupportNeddedThroughAbrpl,
      "isStrongMobileNetworkConnectivity": lleDetails?.lleMasters[0]?.isStrongMobileNetworkConnectivity,
      "isValidEnvironmentAndSustainability": lleDetails?.lleMasters[0]?.isValidEnvironmentAndSustainability,
      "isLocationSociallyValid": lleDetails?.lleMasters[0]?.isLocationSociallyValid,
      "labourLicenceNumber": lleDetails?.lleMasters[0]?.labourLicenceNumber,
      "labourLicenceEndDate": lleDetails?.lleMasters[0]?.labourLicenceEndDate,
      "tradeLicenceNumber": lleDetails?.lleMasters[0]?.tradeLicenceNumber,
      "tradeLicenceEndDate": lleDetails?.lleMasters[0]?.tradeLicenceEndDate,
      "gstNumber": lleDetails?.lleMasters[0]?.gstNumber,
      "nonEncumbranceCertificateNo": lleDetails?.lleMasters[0]?.nonEncumbranceCertificateNo,
      "agreementStartDate": lleDetails?.lleMasters[0]?.agreementStartDate,
      "agreementEndDate": lleDetails?.lleMasters[0]?.agreementEndDate,
      "locationGeotag": lleDetails?.lleMasters[0]?.locationGeotag,
      "documentId": lleDetails?.lleMasters[0]?.documentId,
      "isAgreedToEnvionmentHealthSafetyLawsRegulation": lleDetails?.lleMasters[0]?.isAgreedToEnvionmentHealthSafetyLawsRegulation,
      "isAgreedToResourceSustanability": lleDetails?.lleMasters[0]?.isAgreedToResourceSustanability,
      "isSelfCertified": lleDetails?.lleMasters[0]?.isSelfCertified,
      "createdOn": lleDetails?.lleMasters[0]?.createdOn,
      "createdBy": lleDetails?.lleMasters[0]?.createdBy,
      "updatedOn": lleDetails?.lleMasters[0]?.updatedOn,
      "updatedBy": lleDetails?.lleMasters[0]?.updatedBy,
      "isActive": lleDetails?.lleMasters[0]?.isActive,
      "landArea": lleDetails?.lleMasters[0]?.landArea,
      "documents": lleDetails?.lleMasters[0]?.documents,
      "isMSME": isMSMERadio === 'YES' ? 1 : 0,
      "msmeCategory": msmeCategory,
    }
  }

  const isMSMENo =
    isMSMERadio === 0 ||
    isMSMERadio === "NO";


  const filteredDocuments = documentArray?.map(doc => {
    if (doc.documentType === "MSME_Certificate") {
      return {
        ...doc,
        isActive: isMSMENo ? 0 : 1
      };
    }
    return doc;
  });

  const getFinalData = () => {
  return {
    ...lleDetails,
    isMSME: isMSMERadio === 'YES' ? 1 : 0,
    msmeCategory: isMSMERadio === 'NO' ? '' : msmeCategory,
    lleDetail: {
      ...lleDetails?.lleMasters?.[0],
      documents: documentArray,
    },
  };
};

  const finalData =
  {
    "id": id,
    "name": fullName,
    "contactPersonName": contactPersonDetails.contactPersonFirstName,
    "contactPersonFirstname": contactPersonDetails.contactPersonFirstName,
    "contactPersonMiddlename": contactPersonDetails.contactPersonMiddleName,
    "contactPersonLastname": contactPersonDetails.contactPersonLastName,
    "contactPersonGender": contactPersonDetails.contactPersonGender,
    "contactPersonSalutation": contactPersonDetails.contactPersonSalutation,
    "mobileNo": mobileNumber,
    "bankAccountNumber": accountNumber,
    "bankAccountHolderName": accountHolderName,
    "bankBranch": branchName,
    "bankIfscCode": ifscCode,
    "bankName": bankName,
    "panNumber": panNumber,
    "govtIdCardType": govIDType,
    "govtIdCardNumber": govIDNumber,
    "otherGovtCardType": otherIdType,
    "emailId": emailId,
    "category": lleDetails?.category,
    "urn": urn,
    "isOtpValidated": mobileOTPValidated === true ? true : false,
    "preregistrationShortlisted": lleDetails?.preregistrationShortlisted,
    "registrationStatus": getRegistrationStatus(),
    "scrutinyStatus": lleDetails?.scrutinyStatus,
    "stakeholderStatus": lleDetails?.stakeholderStatus,
    "createdOn": lleDetails?.createdOn,
    "createdBy": lleDetails?.createdBy,
    "updatedOn": lleDetails?.updatedOn,
    "updatedBy": lleDetails?.updatedBy,
    "isActive": 1,
    "lleDetail": {
      "id": lleDetails?.lleMasters[0]?.id,
      "regStakeholderMasterId": lleDetails?.lleMasters[0]?.regStakeholderMasterId,
      "pincode": pincode,
      "address": address,
      "state": states,
      "district": district,
      "revenueCircle": revenueCircle,
      "blockName": blockLists,
      "applicantType": applicantType,
      "highestEducationalQualification": educationQualification,
      "registrationNumber": registrationNo,
      "netWorth": netWorth,
      "workingCapital": workingCapital,
      "existingOccupation": existingOccupation,
      "chippingUnitAddress": chippingAddress,
      "chippingUnitDistrict": chippingDistrict,
      "chippingUnitState": chippingState,
      "chippingUnitPincode": chippingPincode,
      "chippingUnitLatitude": latitude,
      "chippingUnitLongitude": longitude,
      "chippingUnitBlockName": chippingBlockLists,
      "chippingUnitRevenueCircle": chippingRevenueCircle,
      "estimatedBambooQuantity": quantitylle,
      "estimatedLandArea": landArealle,
      "isApplicantAddressInOperationArea": lleDetails?.lleMasters[0]?.isApplicantAddressInOperationArea,
      "applicantAddressRangeFromOperationArea": applicantAddressRangeFromOperationArea,
      "isOptedLandValid": lleDetails?.lleMasters[0]?.isOptedLandValid,
      "landAvailability": landAvailability,
      "landType": landType,
      "roadConnectivity": roadConnectivity,
      "isRoadConnectivityValid": lleDetails?.lleMasters[0]?.isRoadConnectivityValid,
      "isDadicatedTransformerLoaded": lleDetails?.lleMasters[0]?.isDadicatedTransformerLoaded,
      "optedLocationPowerConnectionDistance": optedLocationPowerConnectionDistance,
      "isAlternatePowerSupplyAvailable": lleDetails?.lleMasters[0]?.isAlternatePowerSupplyAvailable,
      "daytimePowerAvailability": daytimePowerAvailability,
      "isApplicantArrangeOwnAmount6070Lacs": lleDetails?.lleMasters[0]?.isApplicantArrangeOwnAmount6070Lacs,
      "isBankSupportNeddedThroughAbrpl": lleDetails?.lleMasters[0]?.isBankSupportNeddedThroughAbrpl,
      "isStrongMobileNetworkConnectivity": lleDetails?.lleMasters[0]?.isStrongMobileNetworkConnectivity,
      "isValidEnvironmentAndSustainability": lleDetails?.lleMasters[0]?.isValidEnvironmentAndSustainability,
      "isLocationSociallyValid": lleDetails?.lleMasters[0]?.isLocationSociallyValid,
      "labourLicenceNumber": labourLicenseNo,
      "labourLicenceEndDate": labourLicenseEndDate ? labourLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
      "tradeLicenceNumber": tradeLicenseNo,
      "tradeLicenceEndDate": tradeLicenseEndDate ? tradeLicenseEndDate : moment(new Date).format(API_DATE_FORMAT),
      "gstNumber": gstNo,
      "nonEncumbranceCertificateNo": nonEncumbranceCertificateNo,
      "agreementStartDate": agreementStartDate,
      "agreementEndDate": agreementEndDate,
      "locationGeotag": lleDetails?.lleMasters[0]?.locationGeotag,
      "documentId": lleDetails?.lleMasters[0]?.documentId,
      "isAgreedToEnvionmentHealthSafetyLawsRegulation": lleDetails?.lleMasters[0]?.isAgreedToEnvionmentHealthSafetyLawsRegulation,
      "isAgreedToResourceSustanability": lleDetails?.lleMasters[0]?.isAgreedToResourceSustanability,
      "isSelfCertified": lleDetails?.lleMasters[0]?.isSelfCertified,
      "createdOn": lleDetails?.lleMasters[0]?.createdOn,
      "createdBy": lleDetails?.lleMasters[0]?.createdBy,
      "updatedOn": lleDetails?.lleMasters[0]?.updatedOn,
      "updatedBy": lleDetails?.lleMasters[0]?.updatedBy,
      "isActive": 1,
      "landArea": landAreaValue + " " + landAreaUnit,
      "documents": filteredDocuments,
      "isMSME": isMSMERadio === 'YES' ? 1 : 0,
      "msmeCategory": isMSMERadio === 'YES' ? msmeCategory : '',
    }
  }

  const updateLle = () => {
    loaderService.showLoader();
    apiClient
      .post(UPDATE_LLE + `?IsRegistrationSubmit=${getSubmit()}`,
        finalData,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        loaderService.hideLoader();
        const updateLleResponse = response?.data
        setCallUpdateApi(false);
        if (updateLleResponse?.isSuccess) {
          getLleDetailsFromUrn();
          if (buttonAction === "preview") {
            setCurrentPage("preview")
          }
          if (buttonAction === "submit" || buttonAction === "save") {
            toast.success(updateLleResponse?.message);
          }
          if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
            onSubmit();
          }
          if (buttonAction === "submit") {
            if (decoded.extension_URN) {
              navigate('/dashboardHome/dashboardStakeHolder');
            }
            else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
              navigate('/resourcedashboard/searchByURN');
            }
            else if (userRole === ROLES.ItAdmin) {
              navigate('/sidebar/viewAllActiveApplications');
            }
            else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
              navigate('/registrationHome/dashboard');
            }
            else if (userRole === ROLES.RegistrationScruitnizer) {
              setCallWorkFlowApi(true);
            }
            else {
              navigate(-1);
            }
          }
        }
        else {
          toast.error(updateLleResponse?.message);
          setCurrentPage("registrationDetails");
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        setApiError(error)
      })
  }

  const onSubmit = () => {
    loaderService.showLoader();
    apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
      {
        "stakeholderMappings": [
          {
            "scrutinizerId": getLocalStorageItem('uuid'),
            "stakeholderID": stakeHolderDetails?.id,
            "stakeholderState": stakeHolderDetails?.lleMasters?.[0]?.state,
            "stakeholderDistrict": stakeHolderDetails?.lleMasters?.[0]?.district,
            "loggedInUserID": getLocalStorageItem('uuid'),
            "isActive": 1,
            // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
          }
        ]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          onActionWorflowSubmit();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const onActionWorflowSubmit = () => {
    loaderService.showLoader();
    apiClient.post(ALLOCATE_WORKFLOW,
      {
        "stakeHolderMasterID": stakeHolderDetails?.id,
        "workflowInitiatorID": getLocalStorageItem('uuid'),
        "workflowReceiverID": "",
        "workflowAction": "Approve",
        "status": "",
        "isStakeHolderAction": false,
        "workflowInitiatorRole": localStorage.getItem('role'),
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data?.message);
          if (localStorage.getItem('uuid'))
            navigate('/registrationHome/dashboard');
          else
            navigate('/dashboardHome/dashboardStakeHolder');
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  return (
    <LleContext.Provider value={{ userType: state?.userType, viewOnly: state?.viewOnly, regScruResourceUpdate, setRegScruResourceUpdate, stakeHolderDetails, personalDetailsSectionOk, bankDetailsSectionOk, agreementDetailsSectionOk, qualificationDetailsSectionOk, chippingLocationDetailsSectionOk, locationDetailsSectionOk, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, setButtonAction, setCallUpdateApi }}>
      <>
        {currentPage === "registrationDetails" && lleDetails && <Container maxWidth="xxl" >
          {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG31</p>}
          <Stack direction="row" alignItems="center" spacing={1} mb={3}>
            <BackButton navigate={navigate} />
            <Typography variant="h5" gutterBottom>
              {t('reg.registrationDetails')}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={4}>
              <TextField fullWidth
                required
                disabled
                type="text"
                label="URN"
                value={urn || ''}
              />
              <BadgeComponent currentLength={urn?.length} maxLength={urnMaxLength} />
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "personal"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "personal" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (personalDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{applicantType === "Individual" ? t('preReg.personalDetails') : t('preReg.organizationDetails')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    <Grid item xs={12} lg={6}>
                      <Typography variant="subtitle2" gutterBottom>
                        {t('preReg.applicantType')}
                      </Typography>
                      <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                        color="primary"
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        value={applicantType}
                        name="applicantType"
                        onChange={(e) => onApplicantClick(e)}
                        exclusive
                        aria-label="Platform"
                      >
                        <ToggleButton value="Individual">{t('preReg.individual')}</ToggleButton>
                        <ToggleButton value="SHG/Co-operative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                        <ToggleButton value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>
                    {/* <Grid item xs={12} lg={4}>
                                    <TextField fullWidth 
                                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                                        type="text"
                                        label={t('preReg.applicantType')}
                                        name="applicantType"
                                        value={applicantType}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{
                                            maxLength: maxNameLength
                                        }}
                                        error={errorMessage.applicantTypeError}
                                        helperText={errorMessage.applicantTypeError}
                                    />
                                </Grid> */}
                    <Grid item xs={12} lg={6} mt={2}>
                      <TextField fullWidth
                        required
                        error={errorMessage.fullNameError}
                        helperText={errorMessage.fullNameError}
                        type="text"
                        label={t('preReg.applicantName')}
                        inputProps={{
                          maxLength: 100

                        }}
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        name="name"
                        value={fullName || ''}
                        multiline
                        onChange={(e) => onFullNameChange(e)}
                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={fullName?.length} maxLength={maxNameLength} />
                    </Grid>
                    {applicantType !== 'Individual' && (
                      <Grid item xs={12} lg={2}>
                        <FormControl>
                          <FormLabel
                            sx={{
                              fontWeight: 600,
                              fontSize: '1rem',
                              color: 'text.primary'
                            }}
                          >
                            Is MSME?
                          </FormLabel>

                          <ToggleButtonGroup
                            value={isMSMERadio}
                            exclusive
                            onChange={(e, value) => value && setIsMSMERadio(value)}
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                            sx={{ mt: 1 }}
                          >
                            <ToggleButton value="YES">Yes</ToggleButton>
                            <ToggleButton value="NO">No</ToggleButton>
                          </ToggleButtonGroup>
                        </FormControl>
                      </Grid>
                    )}
                    {applicantType !== 'Individual' && isMSMERadio === 'YES' && (
                      <Grid item xs={12} lg={4} mt={3}>
                        <FormControl fullWidth>
                          <InputLabel>MSME Category</InputLabel>
                          <Select
                            label="MSME Category"
                            value={msmeCategory}
                            onChange={(e) => setMsmeCategory(e.target.value)}
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                          >
                            {MSME_CATEGORY_OPTIONS.map(option => (
                              <MenuItem key={option.key} value={option.key}>
                                <strong>{option.key}</strong> — {option.description}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}
                    {applicantType !== 'Individual' && isMSMERadio === 'YES' && (
                      <Grid item xs={12} lg={6} mt={2}>
                        <FileUploadMUI
                          key="MSME_Certificate"
                          documentList={documentArray}
                          documentType="MSME_Certificate"
                          callBackDocumentUpload={onUploadCallBack}
                          stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                          title="Upload MSME Certificate"
                          stakeholderType="LLE"
                          disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          documentError="msmeDocError"
                        />
                      </Grid>
                    )}


                    <Grid item xs={12}>
                      <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                        {t('preReg.contactPersonDetails')}
                      </Typography>
                    </Grid>

                    <Grid item xs={4} lg={2}>
                      <FormControl fullWidth>
                        <InputLabel>{t('preReg.salutation')}</InputLabel>
                        <Select
                          label={t('preReg.salutation')}
                          name='contactPersonSalutation'
                          disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                          value={contactPersonDetails.contactPersonSalutation}
                          onChange={(e) => onContactPersonDetailChange(e)}
                          onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                          {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                        {/* <FormHelperText sx={{ color: 'red' }}>{errorMessage?.categoryError}</FormHelperText> */}
                      </FormControl>
                    </Grid>
                    <Grid item xs={8} lg={4}>
                      <TextField fullWidth
                        required
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        error={errorMessage.contactPersonFirstNameError}
                        helperText={errorMessage.contactPersonFirstNameError}
                        type="text"
                        inputProps={{
                          maxLength: maxNameLength
                        }}
                        label={t('preReg.firstname')}
                        name="contactPersonFirstName"
                        value={contactPersonDetails.contactPersonFirstName}
                        onChange={(e) => onContactPersonDetailChange(e)}
                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={contactPersonDetails?.contactPersonFirstName?.length} maxLength={maxNameLength} />
                    </Grid>
                    <Grid item xs={6} lg={3}>
                      <TextField fullWidth
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        inputProps={{
                          maxLength: maxNameLength
                        }}
                        label={t('preReg.middlename')}
                        name="contactPersonMiddleName"
                        value={contactPersonDetails.contactPersonMiddleName}
                        onChange={(e) => onContactPersonDetailChange(e)}
                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={contactPersonDetails?.contactPersonMiddleName?.length} maxLength={maxNameLength} />
                    </Grid>
                    <Grid item xs={6} lg={3}>
                      <TextField fullWidth
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        inputProps={{
                          maxLength: maxNameLength
                        }}
                        label={t('preReg.lastname')}
                        name="contactPersonLastName"
                        value={contactPersonDetails.contactPersonLastName}
                        onChange={(e) => onContactPersonDetailChange(e)}
                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={contactPersonDetails?.contactPersonLastName?.length} maxLength={maxNameLength} />
                    </Grid>
                    <Grid item xs={4} lg={2}>
                      <FormControl fullWidth>
                        <InputLabel>{t('preReg.gender')}</InputLabel>
                        <Select
                          label={t('preReg.gender')}
                          disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                          name='contactPersonGender'
                          value={contactPersonDetails.contactPersonGender}
                          onChange={(e) => onContactPersonDetailChange(e)}
                          onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }}>
                          {GENDER.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={8} lg={4}>
                      <TextField fullWidth
                        required
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        error={errorMessage.mobileNoError}
                        helperText={errorMessage.mobileNoError}
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        label={t('preReg.mobileNo')}
                        name="mobileNo"
                        value={mobileNumber}
                        onChange={(e) => handleChange(e)}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()}
                      />
                      <BadgeComponent currentLength={mobileNumber?.length} maxLength={mobileNoMaxLength} />
                      {verifyMobileNo === true ?
                        <div>
                          <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        : mobileOTPValidated === true ? <div className="commonVerifyText" hidden={!mobileOTPValidated} ><a href="#" style={{ marginLeft: "4vw" }}>Verified</a>
                          <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :
                          <button className="commonVerifyText" style={{ marginLeft: "0vw", float: "right" }} onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>
                      }
                    </Grid>
                    {verifyMobileNo &&
                      <Grid item xs={3} lg={2}>
                        <TextField
                          type="number"
                          onFocus={handleNumberFieldFocus}
                          disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                          onChange={(e) => onOtpChange(e)}
                          value={otpValue}
                          label={t('preReg.otp')}
                          onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === "Enter") && evt.preventDefault()} />
                      </Grid>
                    }
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        error={errorMessage?.emailIdError}
                        helperText={errorMessage?.emailIdError}
                        required
                        type="text"
                        label={t('main.email')}
                        name="emailId"
                        value={emailId}
                        onChange={(e) => onEmailChange(e)}
                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={emailId?.length} maxLength={emailUrnPassMaxLength} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth
                        required
                        error={errorMessage.panNumberError}
                        helperText={errorMessage.panNumberError}
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                        label={t('reg.panNumber')}
                        name="panNumber"
                        value={panNumber}
                        onChange={(e) => onPanNumberChange(e)}
                        InputProps={{
                          maxLength: 10
                        }}
                        style={{ textTransform: "uppercase" }}
                      />
                      <BadgeComponent currentLength={panNumber?.length} maxLength={mobileNoMaxLength} />
                      <FileUploadMUI key={PAN_CARD}
                        documentList={documentArray}
                        documentType={PAN_CARD}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadPanDoc')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="panDocError"
                      />
                    </Grid>
                    {applicantType === 'Individual' ?
                      <>
                        <Grid item xs={6} lg={4}>
                          <FormControl fullWidth>
                            <InputLabel>{t('preReg.addressProof')}</InputLabel>
                            <Select
                              label={t('preReg.addressProof')}
                              name="govtIdCardType"
                              disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                              value={govIDType}
                              onChange={(e) => onGovIdypeChange(e)}
                            >
                              {GOV_ID_LIST.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}

                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={6} lg={4}>
                          <TextField fullWidth
                            error={errorMessage.govtIdCardNumberError}
                            helperText={errorMessage.govtIdCardNumberError}
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                            type="text"
                            name="govtIdCardNumber"
                            label={govIDType === "Aadhaar ID" ? t('preReg.enterLast4digit') : govIDType === "Voter ID" ? t('preReg.enterVoterId') : govIDType === "Driving Licence" ? t('preReg.enterDrivinglicense') : t('preReg.enterBankPassbookNo')}
                            onChange={(e) => onClickAadharChange(e)}
                            value={govIDNumber}
                            InputProps={{
                              style: { textTransform: "uppercase" }
                            }}
                          />
                          <BadgeComponent currentLength={govIDNumber?.length} maxLength={govtIDcardLength} />
                          <FileUploadMUI key={ID_PROOF}
                            documentList={documentArray}
                            documentType={ID_PROOF}
                            callBackDocumentUpload={onUploadCallBack}
                            stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                            title={t('reg.uploadAddressProofDoc')}
                            stakeholderType="LLE"
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                            errorMessage={errorMessage}
                            setErrorMessage={setErrorMessage}
                            documentError="idProofDocError"
                          />
                          {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                        </Grid>
                      </> :
                      <>
                        <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6} lg={4}>
                          <FormControl fullWidth>
                            <InputLabel>{t('preReg.addressProof')}</InputLabel>
                            <Select
                              label={t('preReg.addressProof')}
                              name="govtIdCardType"
                              disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                              value={govIDType}
                              onChange={(e) => onGovIdypeChange(e)}
                            >
                              <MenuItem disabled> Address Proof</MenuItem>
                              {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}

                            </Select>
                          </FormControl>
                        </Grid>
                        {govIDType == "Other" &&
                          <Grid item xs={6} lg={4}>
                            <TextField fullWidth
                              disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                              type="text"
                              label={t('preReg.enterIdProof')}
                              name="otherGovtCardType"
                              error={errorMessage.otherCardError}
                              helperText={errorMessage.otherCardError}
                              defaultValue={otherIdType}
                              onChange={(e) => onGovIdypeChange(e)}
                              InputProps={{
                                style: { textTransform: "uppercase" }
                              }} />

                          </Grid>}
                        <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6} lg={4}>
                          <TextField fullWidth
                            error={errorMessage.govtIdCardNumberError}
                            helperText={errorMessage.govtIdCardNumberError}
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                            type="text"
                            name="govtIdCardNumber"
                            label={govIDType === "MOA" ? t('preReg.enterMOA') : govIDType === "Registration Certificate" ? t('preReg.enterRegNo') : govIDType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                            defaultValue={details.govtIdCardNumber}
                            value={govIDNumber}
                            onChange={(e) => onClickAadharChange(e)}
                            InputProps={{
                              style: { textTransform: "uppercase" }
                            }}
                          />
                          <BadgeComponent currentLength={govIDNumber?.length} maxLength={govtIDcardLength} />
                          <FileUploadMUI key={ID_PROOF}
                            documentList={documentArray}
                            documentType={ID_PROOF}
                            callBackDocumentUpload={onUploadCallBack}
                            stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                            title={t('reg.uploadAddressProofDoc')}
                            stakeholderType="LLE"
                            disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                            errorMessage={errorMessage}
                            setErrorMessage={setErrorMessage}
                            documentError="idProofDocError"
                          />
                          {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                        </Grid>
                      </>}
                    <Grid item xs={12}>
                      <TextField fullWidth
                        disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                        error={errorMessage?.addressError}
                        helperText={errorMessage?.addressError}
                        required
                        type="text"
                        label={t('main.address')}
                        name="address"
                        value={address}
                        multiline
                        onChange={(e) => onAddressChange(e)}

                        onKeyDown={(evt) => { evt.key === 'Enter' && evt.preventDefault() }} />
                      <BadgeComponent currentLength={address?.length} maxLength={addressMaxLength} />
                    </Grid>
                    <CommonPincodeMUI setErrorMessage={setErrorMessage}
                      fullWidth={true}
                      revenueNotRequired={true}
                      pincode={pincode}
                      state={states}
                      district={district}
                      revenueCircle={revenueCircle}
                      blockName={blockLists}
                      isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                      onHandleCallback={getUpdatedAddressData}
                      pincodeError={errorMessage.pincodeError}
                      searchError={errorMessage.searchError}
                      handleChangeSelect={handleChangeSelect}
                    />
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.personalCommentError}
                        error={errorMessage.personalCommentError}
                        name="comment"
                        inputProps={{
                          maxLength: approverCommentMaxLength,
                        }}
                        multiline
                        disabled={!shouldActOnSection.personal_details || state?.viewOnly}
                        value={personalComment}
                        onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />
                      <BadgeComponent currentLength={personalComment?.length} maxLength={approverCommentMaxLength} />
                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                      </div> */}
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || state?.viewOnly} checked={personalDetailsSectionOk}
                          onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.personal_details || state?.viewOnly}
                        onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={personalComments ? personalComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>

              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "bank"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "bank" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{t('preReg.bankDetails')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.bankAccountNumberError}
                        helperText={errorMessage.bankAccountNumberError}
                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        label={t('preReg.accountNo')}
                        name="bankAccountNumber"
                        value={accountNumber}
                        onChange={(e) => onbankAccountNumberChange(e)}

                        inputProps={{
                          maxLength: 20
                        }}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                      />
                      <BadgeComponent currentLength={accountNumber?.length} maxLength={govtIDcardLength} />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth required error={errorMessage.bankAccountHolderNameError}
                        helperText={errorMessage.bankAccountHolderNameError}
                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                        type="text"
                        label={t('preReg.accountHolderName')}
                        name="bankAccountHolderName"
                        value={accountHolderName}
                        onChange={(e) => onbankAccountHolderNameChange(e)}
                        InputProps={{
                          maxLength: maxNameLength

                        }} />
                      <BadgeComponent currentLength={accountHolderName?.length} maxLength={maxNameLength} />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.ifscCodeError}
                        helperText={errorMessage.ifscCodeError}
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                        name="bankIfscCode"
                        label={t('preReg.ifscCode')}
                        value={ifscCode}
                        onChange={(e) => onbankIfscChange(e)}
                        onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton color='primary' disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} aria-label="delete" onClick={() => getBankDetails()}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          maxLength: 20

                        }}
                      ></TextField>
                      <BadgeComponent currentLength={ifscCode?.length} maxLength={govtIDcardLength} />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        type="text"
                        label={t('preReg.branch')}
                        name="bankBranch"
                        value={branchName || ''}
                        disabled />
                      <FileUploadMUI key={BANK_CANCELLED_CHEQUE}
                        documentList={documentArray}
                        documentType={BANK_CANCELLED_CHEQUE}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadPassbookCancelledCheck')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="bankDocError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}

                    </Grid>
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.bankCommentError}
                        error={errorMessage.bankCommentError}
                        name="comment"
                        inputProps={{
                          maxLength: approverCommentMaxLength,
                        }}
                        multiline
                        disabled={!shouldActOnSection.bank_details || state?.viewOnly}
                        value={bankComment}
                        onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />
                      <BadgeComponent currentLength={bankComment?.length} maxLength={approverCommentMaxLength} />
                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                      </div> */}
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || state?.viewOnly} checked={bankDetailsSectionOk}
                          onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.bank_details || state?.viewOnly}
                        onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={bankComments ? bankComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "agreement"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "agreement" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (agreementDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{t('preReg.licenseAgreementDetails')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    <Grid item xs={12} lg={6}>
                      <FormControl fullWidth >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            label={t('preReg.agreementStartDate')}
                            inputFormat="DD/MM/YYYY"
                            value={agreementStartDateDisplay}
                            name="agreementStartDate"
                            onChange={(e) => onAgreementStartDateChange(e)}
                            disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{ minWidth: 750 }}
                          />
                        </LocalizationProvider>
                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementDateError}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            inputFormat="DD/MM/YYYY"
                            value={agreementEndDateDisplay}
                            label={t('preReg.agreementEndDate')}
                            name="agreementEndDate"
                            onChange={(e) => onAgreementEndDateChange(e)}
                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                            disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{ minWidth: 750 }}
                          />
                        </LocalizationProvider>
                      </FormControl>
                      <FileUploadMUI key={LOI_ABRPL_AGREEMENT}
                        documentList={documentArray}
                        documentType={LOI_ABRPL_AGREEMENT}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadLoiAgreement')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="agreementDocError"
                      />
                    </Grid>
                    <Grid item xs={12} lg={6} mt={1}>
                      <TextField fullWidth
                        required
                        error={errorMessage.tradeLicenseNoError}
                        helperText={errorMessage.tradeLicenseNoError}
                        type="text"
                        label={t('reg.tradeLicenseNo')}
                        value={tradeLicenseNo}
                        onChange={(e) => onTradeLicenseNoChange(e)}
                        InputProps={{
                          maxLength: 20,
                          style: { textTransform: "uppercase" }
                        }}

                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)} />
                      <BadgeComponent currentLength={tradeLicenseNo?.length} maxLength={govtIDcardLength} />
                      <FileUploadMUI key={LLE_TRADE_LICENSE}
                        documentList={documentArray}
                        documentType={LLE_TRADE_LICENSE}
                        callBackDocumentUpload={onUploadCallBack} stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('reg.uploadTradeLicenseProofDoc')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="tradeLicenseDocError"
                      />

                      {/* <div className='mandatory_field'>{errorMessage.tradeLicenseDocError}</div> */}
                    </Grid>
                    <Grid item xs={12} lg={6} mt={1}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker
                            required
                            inputFormat="DD/MM/YYYY"
                            label={t('reg.validTill')}
                            value={tradeLicenseEndDateDisplay}
                            name="tradeLicenseEndDate"
                            onChange={(e) => onTradeLicenseEndDateChange(e)}
                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                            disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{ paddingRight: '3%' }}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.labourLicenseNoError}
                        helperText={errorMessage.labourLicenseNoError}
                        type="text"
                        label={t('reg.labourLicenseNo')}
                        value={labourLicenseNo}
                        onChange={(e) => onLabourLicenseNoChange(e)}
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        InputProps={{
                          maxLength: 20,
                          style: { textTransform: "uppercase" }
                        }} />
                      <BadgeComponent currentLength={labourLicenseNo?.length} maxLength={govtIDcardLength} />
                      <FileUploadMUI key={LABOUR_LICENCE}
                        documentList={documentArray}
                        documentType={LABOUR_LICENCE}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('reg.uploadLabourLicenseDoc')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="labourLicenseDocError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.labourLicenseDocError}</div> */}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DesktopDatePicker label={t('reg.validTill')}
                            inputFormat="DD/MM/YYYY"
                            value={labourLicenseEndDateDisplay}
                            onChange={(e) => onLabourLicenseEndDateChange(e)}
                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                            disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>

                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.gstNoError}
                        helperText={errorMessage.gstNoError}
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        label={t('preReg.gstNo')}
                        value={gstNo}
                        onChange={(e) => onGstNoChange(e)}
                        InputProps={{
                          maxLength: 20,
                          style: { textTransform: "uppercase" }
                        }} />
                      <BadgeComponent currentLength={gstNo?.length} maxLength={govtIDcardLength} />
                      <FileUploadMUI key={GST}
                        documentList={documentArray}
                        documentType={GST}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadGst')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="gstDocError"
                      />

                      {/* <div className='mandatory_field'>{errorMessage.gstDocError}</div> */}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        error={errorMessage.nonEncumbranceCertificateNoError}
                        helperText={errorMessage.nonEncumbranceCertificateNoError}
                        type="text"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        label={t('preReg.nonEcumbranceCertificateNo')}
                        value={nonEncumbranceCertificateNo}
                        onChange={(e) => onNonEncumbranceCertificateNoChange(e)}
                        InputProps={{
                          maxLength: 20,
                          style: { textTransform: "uppercase" }
                        }} />
                      <BadgeComponent currentLength={nonEncumbranceCertificateNo?.length} maxLength={govtIDcardLength} />
                      <FileUploadMUI key={NON_ENCUMBRANCE_CERTI}
                        documentList={documentArray}
                        documentType={NON_ENCUMBRANCE_CERTI}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadNonEcumbraceDoc')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="nonEncumDocError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.nonEncumDocError}</div> */}
                    </Grid>
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.agreementCommentError}
                        error={errorMessage.agreementCommentError}
                        name="comment"
                        inputProps={{
                          maxLength: approverCommentMaxLength,
                        }}
                        multiline
                        disabled={!shouldActOnSection.agreement_details || state?.viewOnly}
                        value={agreementComment}
                        onChange={(e) => setAgreementComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />
                      <BadgeComponent currentLength={agreementComment?.length} maxLength={approverCommentMaxLength} />
                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${agreementComment?.length > characterLimit ? 'danger' : 'primary'}`}>{agreementComment?.length}/{characterLimit}</Badge>
                      </div> */}
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.agreement_details || state?.viewOnly} checked={agreementDetailsSectionOk}
                          onChange={(e) => setAgreementDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.agreement_details || state?.viewOnly}
                        onClick={() => onSaveComment(agreementComment, "agreement_details", agreementDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={agreementComments ? agreementComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "qualification"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "qualification" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (qualificationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (qualificationDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{t('preReg.qualificationFinancialDetails')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (qualificationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    {applicantType === 'Individual' ?
                      <>
                        <Grid item xs={12}>
                          <Typography variant="h6" gutterBottom>
                            {t('preReg.qualification')}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <TextField fullWidth
                            required
                            error={errorMessage.educationQualificationError}
                            helperText={errorMessage.educationQualificationError}
                            type="text"
                            disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                            label={t('preReg.highestQualification')}
                            name="educationQualification"
                            value={educationQualification}
                            onChange={(e) => educationQualificationChange(e)}
                          />
                          <BadgeComponent currentLength={educationQualification?.length} maxLength={govtIDcardLength} />
                          <FileUploadMUI key={HIGHEST_QUALIFICATION}
                            documentList={documentArray}
                            documentType={HIGHEST_QUALIFICATION}
                            callBackDocumentUpload={onUploadCallBack}
                            stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                            title={t('reg.uploadQualificationProofDoc')}
                            stakeholderType="LLE"
                            disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                            errorMessage={errorMessage}
                            setErrorMessage={setErrorMessage}
                            documentError="highestQualiDocError"
                          />
                          {/* <div className='mandatory_field'>{errorMessage.highestQualiDocError}</div> */}
                        </Grid></> : <Grid item xs={12} lg={6}>
                        <Typography variant="h6" gutterBottom>
                          {t('preReg.credentials')}
                        </Typography>
                        <TextField fullWidth
                          required
                          error={errorMessage.registrationNoError}
                          helperText={errorMessage.registrationNoError}
                          type="text"
                          label="MOA/Registration/Incorporation No"
                          name="educationQualification"
                          value={registrationNo}
                          onChange={(e) => registrationNoChange(e)}
                          disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                        />
                        <BadgeComponent currentLength={registrationNo?.length} maxLength={govtIDcardLength} />
                        <FileUploadMUI key={MOA_REGISTRATION_CERTIFICATE}
                          documentList={documentArray}
                          documentType={MOA_REGISTRATION_CERTIFICATE}
                          callBackDocumentUpload={onUploadCallBack}
                          stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                          title="Upload registration certificate"
                          stakeholderType="LLE"
                          disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          documentError="regCertDocError"
                        />
                        {/* <div className='mandatory_field'>{errorMessage.regCertDocError}</div> */}
                      </Grid>}
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.typeOfOccError}
                        helperText={errorMessage.typeOfOccError}
                        disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                        type="text"
                        label={t('preReg.typeOfBusinessOccupation')}
                        name="typeOfOcc"
                        value={existingOccupation}
                        onChange={(e) => existingOccupationChange(e)}
                      />
                      <BadgeComponent currentLength={existingOccupation?.length} maxLength={govtIDcardLength} />
                      <FileUploadMUI key={EXISTING_OCC}
                        documentList={documentArray}
                        documentType={EXISTING_OCC}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t("preReg.uploadUdyamCertificate")}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="existingOCCDocError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.existingOCCDocError}</div> */}
                      <FileUploadMUI key={VALATION_REPORT}
                        documentList={documentArray}
                        documentType={VALATION_REPORT}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadValuationDueDiligence')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="valuationDocError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.valuationDocError}</div> */}
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom>
                        {t('preReg.financialInformation')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        error={errorMessage.netWorthError}
                        helperText={errorMessage.netWorthError}
                        label={t('preReg.networth') + t('preReg.inINR')}
                        name="netWorth"
                        value={netWorth}
                        onChange={(e) => onNetWorthChange(e)}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                      />
                      <BadgeComponent currentLength={netWorth?.length} maxLength={govtIDcardLength} />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <TextField fullWidth
                        required
                        error={errorMessage.workingCapitalError}
                        helperText={errorMessage.workingCapitalError}
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        label={t('preReg.workingCapital') + t('preReg.inINR')}
                        name="workingCapital"
                        value={workingCapital}
                        onChange={(e) => onWorkingCapitalChange(e)}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                        disabled={!enableFieldFunction(shouldActOnSection.qualification_details, false)}
                      />
                      <BadgeComponent currentLength={workingCapital?.length} maxLength={govtIDcardLength} />
                    </Grid>
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.qualificationCommentError}
                        error={errorMessage.qualificationCommentError}
                        name="comment"
                        inputProps={{
                          maxLength: 300,
                        }}
                        multiline
                        disabled={!shouldActOnSection.qualification_details || state?.viewOnly}
                        value={qualificationComment}
                        onChange={(e) => setQualificationComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${qualificationComment?.length > characterLimit ? 'danger' : 'primary'}`}>{qualificationComment?.length}/{characterLimit}</Badge>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.qualification_details || state?.viewOnly} checked={qualificationDetailsSectionOk}
                          onChange={(e) => setQualificationDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.qualification_details || state?.viewOnly}
                        onClick={() => onSaveComment(qualificationComment, "qualification_details", qualificationDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={qualificationComments ? qualificationComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "chippingLocation"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "chippingLocation" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (chippingLocationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (chippingLocationDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{t('preReg.optedChippingLocationDetails')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (chippingLocationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    <Grid item xs={12}>
                      <TextField fullWidth
                        required
                        multiline
                        disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                        error={errorMessage.chippingaddressError}
                        helperText={errorMessage.chippingaddressError}
                        type="text"
                        label={t('main.address')}
                        name="address"
                        value={chippingAddress}
                        onChange={(e) => onChippingAddressChange(e)}
                      />
                      <BadgeComponent currentLength={chippingAddress?.length} maxLength={addressMaxLength} />
                    </Grid>
                    <CommonPincodeMUI setErrorMessage={setErrorMessage}
                      fullWidth={true}
                      pincode={chippingPincode}
                      state={chippingState}
                      district={chippingDistrict}
                      isDisabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                      revenueCircle={chippingRevenueCircle}
                      blockName={chippingBlockLists}
                      onHandleCallback={getUpdatedChippingAddressData}
                      pincodeError={errorMessage.chippingpincodeError}
                      searchError={errorMessage.chippingsearchError}
                      handleChangeSelect={handleChippingChangeSelect}
                    />
                    <Grid item xs={12}>
                      <LocationPointMUI
                        latitudeLabel="Latitude"
                        longitudeLabel="Longitude"
                        latitudeName={t('preReg.latitude')}
                        longitudeName={t('preReg.longitude')}
                        latitude={latitude}
                        longitude={longitude}
                        callBackLocation={onLocationPoint}
                        isDisabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                      />
                      <FileUploadMUI key={GEOCODE_LOCATION}
                        documentList={documentArray}
                        documentType={GEOCODE_LOCATION}
                        callBackDocumentUpload={onUploadCallBack}
                        stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                        title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                        stakeholderType="LLE"
                        disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        documentError="landPicError"
                      />
                      {/* <div className='mandatory_field'>{errorMessage.landPicError}</div> */}
                    </Grid>
                    <Grid item xs={12}>
                      <TextField fullWidth
                        required
                        error={errorMessage.landAreaError}
                        helperText={errorMessage.landAreaError}
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        label={t('preReg.landArea')}
                        name="landAreaValue"
                        disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                        value={landAreaValue}
                        onChange={(e) => onLandAreaChange(e)}
                        InputProps={{
                          endAdornment: (
                            <Select
                              variant="standard"
                              size="small"
                              name="landAreaUnit"
                              value={landAreaUnit}
                              disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                              onChange={(e) => onLandAreaChange(e)}
                            >
                              {LAND_AREA_UNIT.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={{ marginBottom: "1em", display: "flex", flexDirection: "row" }} gutterBottom>
                        {t('preReg.estimatedBambooAvailability')}<Typography style={{ marginTop: 4 }} variant="subtitle2" gutterBottom>
                          {t('preReg.within4050radius')}
                        </Typography>
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={6}>
                          <TextField fullWidth
                            required
                            error={errorMessage.quantitylleError}
                            helperText={errorMessage.quantitylleError}
                            type="number"
                            onFocus={handleNumberFieldFocus}
                            label={t('preReg.quantity')}
                            name="quantitylle"
                            disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                            value={quantitylle || ''}
                            onChange={(e) => onQuantityhandleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} />
                          <BadgeComponent currentLength={quantitylle?.length} maxLength={govtIDcardLength} />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <TextField fullWidth
                            required
                            error={errorMessage.landArealleError}
                            helperText={errorMessage.landArealleError}
                            type="number"
                            onFocus={handleNumberFieldFocus}
                            label={t('preReg.landAreaBigha')}
                            disabled={!enableFieldFunction(shouldActOnSection.chippingLocation_details, false)}
                            name="landArealle"
                            value={landArealle || ''}
                            onChange={(e) => OnLandAreahandleChange(e)}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                          />
                          <BadgeComponent currentLength={landArealle?.length} maxLength={govtIDcardLength} />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.chippingLocationCommentError}
                        error={errorMessage.chippingLocationCommentError}
                        name="comment"

                        inputProps={{
                          maxLength: 300,
                        }}
                        multiline
                        disabled={!shouldActOnSection.chippingLocation_details || state?.viewOnly}
                        value={chippingLocationComment}
                        onChange={(e) => setChippingLocationComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />

                      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${chippingLocationComment?.length > characterLimit ? 'danger' : 'primary'}`}>{chippingLocationComment?.length}/{characterLimit}</Badge>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.chippingLocation_details || state?.viewOnly} checked={chippingLocationDetailsSectionOk}
                          onChange={(e) => setChippingLocationDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.chippingLocation_details || state?.viewOnly}
                        onClick={() => onSaveComment(chippingLocationComment, "chippingLocation_details", chippingLocationDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={chippingLocationComments ? chippingLocationComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Accordion mt={1} expanded={expandedSection === "location"}
                onChange={(event, expanded) => {
                  setExpandedSection(expanded ? "location" : "");
                }}>
                <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (locationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
                  expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                >
                  <Stack ml={2} display="flex" alignItems="center" direction="row">
                    {showCommentSection && !regScruResourceUpdate && (locationDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
                    <Typography variant="subtitle1">{t('preReg.informationAboutOptedLocation')}</Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (locationDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
                    <Grid container spacing={2} direction="row" mt={1} ml={2}>
                      <Grid item xs={12} lg={6}>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                          {t('preReg.applicantPermanentResidence')}
                        </Typography>
                        <RadioGroup
                          defaultValue={WITHIN_25_KM}
                          name="lle_applicant_address"
                        >
                          <FormControlLabel value={WITHIN_25_KM} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={applicantAddressRangeFromOperationArea === WITHIN_25_KM} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.within25km')} />
                          <FormControlLabel value={BEYOND_25_KM} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={applicantAddressRangeFromOperationArea === BEYOND_25_KM} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.beyond25km')} />
                          <FormControlLabel value={ADJACENT_DISTRICT} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={applicantAddressRangeFromOperationArea === ADJACENT_DISTRICT} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.adjacentDistrict')} />
                          <FormControlLabel value={OTHER_DISTRICT} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={applicantAddressRangeFromOperationArea === OTHER_DISTRICT} onChange={(e) => onApplicantAddressRangeChange(e)} />} label={t('preReg.otherDistrict')} />
                        </RadioGroup>
                        <FileUploadMUI key={APPLICATION_ADDRESS_EVIDENCE}
                          documentList={documentArray}
                          documentType={APPLICATION_ADDRESS_EVIDENCE}
                          callBackDocumentUpload={onUploadCallBack}
                          stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                          title={t('reg.uploadResidencePrrofMoaAdhar')}
                          stakeholderType="LLE"
                          disabled={!enableFieldFunction(shouldActOnSection.location_details, false)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          documentError="addressProofDocError"
                        />

                        {/* <div className='mandatory_field'>{errorMessage.addressProofDocError}</div> */}
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                          {t('preReg.availabilitOfLandForChippingUnit')} <Typography style={{ marginTop: 4 }} variant="subtitle2" gutterBottom>{t('preReg.ownOrlease')}</Typography>
                        </Typography>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue={MORE_THAN_4_BIGAH}
                          name="land_availability"
                        >
                          <FormControlLabel value={MORE_THAN_4_BIGAH} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={landAvailability === MORE_THAN_4_BIGAH} onChange={(e) => landAvailabilityOnChange(e)} />} label={t('preReg.morethan4bighas')} />
                          <FormControlLabel value={BTWN_3_4_BIGAH} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={landAvailability === BTWN_3_4_BIGAH} onChange={(e) => landAvailabilityOnChange(e)} />} label={t('preReg.between3to4bighas')} />
                        </RadioGroup>
                        <Typography variant="body2" gutterBottom>
                          {t('preReg.optedLandDescript')}
                        </Typography>
                        <Typography variant="subtitle2" mt={2} gutterBottom>
                          {t('preReg.ownnershipType')}
                        </Typography>
                        <RadioGroup row
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="Owned"
                          name="Owned_type"
                        >
                          <FormControlLabel value="Owned" control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={landType === "Owned"} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.owned')} />
                          <FormControlLabel value="Leased" control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={landType === "Leased"} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.lease')} />
                        </RadioGroup>
                        <FileUploadMUI key={LAND_DOCUMENT}
                          documentList={documentArray}
                          documentType={LAND_DOCUMENT}
                          callBackDocumentUpload={onUploadCallBack}
                          stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                          title={showLeasedLabel ? t('preReg.uploadJamabandiReceiptLandOwnerTax') : t('preReg.uploadJamabandiKhajnaTax')}
                          stakeholderType="LLE"
                          disabled={!enableFieldFunction(shouldActOnSection.location_details, false)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          documentError="landDocError"
                        />
                        {/* <div className='mandatory_field'>{errorMessage.landDocError}</div> */}
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} direction="row" mt={1} ml={2}>
                      <Grid item xs={12} lg={6}>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                          {t('preReg.roadConnectivity')}
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                          {t('preReg.roadConnectivityDescrip')}
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                          {t('preReg.optedPlotIs')}
                        </Typography>
                        <RadioGroup
                          defaultValue="Adjacent to an existing bitumen/block road"
                          name="Opted_plot"
                        >
                          <FormControlLabel value="Adjacent to an existing bitumen/block road" control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={roadConnectivity === "Adjacent to an existing bitumen/block road"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToBitumenBlockRoad')} />
                          <FormControlLabel value="Adjacent to an existing motorable gravel road" control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={roadConnectivity === "Adjacent to an existing motorable gravel road"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToMotorableGravelRoad')} />
                          <FormControlLabel value="Requires additional road development less than 500 meters" control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={roadConnectivity === "Requires additional road development less than 500 meters"} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.requireAdditionalRoad')} />
                        </RadioGroup>
                        <FileUploadMUI key={ROAD_PHOTO}
                          documentList={documentArray}
                          documentType={ROAD_PHOTO}
                          callBackDocumentUpload={onUploadCallBack}
                          stakeholderDetailId={lleDetails?.lleMasters[0]?.id}
                          title={t('preReg.uploadPhotoOfApproachRoad')}
                          stakeholderType="LLE"
                          disabled={!enableFieldFunction(shouldActOnSection.location_details, false)}
                          errorMessage={errorMessage}
                          setErrorMessage={setErrorMessage}
                          documentError="roadPicError"
                        />
                        {/* <div className='mandatory_field'>{errorMessage.roadPicError}</div> */}
                        <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                          {t('preReg.powerConnectivity11kvline')}
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                          {t('preReg.distanceFromDistribution')}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                          {t('preReg.powerConnectionAvailable')}
                        </Typography>
                        <RadioGroup
                          defaultValue={WITHIN_100_METER}
                          name="power-connection"
                        >
                          <FormControlLabel value={WITHIN_100_METER} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={optedLocationPowerConnectionDistance === WITHIN_100_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.within100mtr')} />
                          <FormControlLabel value={BTWN_100_500_METER} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={optedLocationPowerConnectionDistance === BTWN_100_500_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn100_500mtr')} />
                          <FormControlLabel value={BTWN_500_1_METER} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={optedLocationPowerConnectionDistance === BTWN_500_1_METER} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn500mtr_1km')} />
                        </RadioGroup>
                        <Typography variant="subtitle1" style={{ marginBottom: "1em" }} gutterBottom>
                          {t('preReg.daytimePowerAvailability')}
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                          {t('preReg.powerAvailabilityDescrip')}
                        </Typography>
                        <Typography variant="subtitle1" style={{ marginTop: "1em" }} gutterBottom>
                          {t('preReg.powerAvailableFor')}
                        </Typography>
                        <RadioGroup
                          defaultValue={MORE_THAN_8_HR}
                          name="day-time-power"
                        >
                          <FormControlLabel value={MORE_THAN_8_HR} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={daytimePowerAvailability === MORE_THAN_8_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.moreThan8hour')} />
                          <FormControlLabel value={BTWN_6_8_HR} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={daytimePowerAvailability === BTWN_6_8_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn6_8hour')} />
                          <FormControlLabel value={BTWN_4_6_HR} control={<Radio disabled={!enableFieldFunction(shouldActOnSection.location_details, false)} checked={daytimePowerAvailability === BTWN_4_6_HR} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn4_6hour')} />
                        </RadioGroup>
                      </Grid>
                    </Grid>
                  </Grid>
                  {showCommentSection && <><Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                    <Grid item xs={7}>
                      <TextField sx={{ width: "100%" }}
                        label={t('reg.comment')}
                        helperText={errorMessage.locationCommentError}
                        error={errorMessage.locationCommentError}
                        name="comment"
                        inputProps={{
                          maxLength: 300,
                        }}
                        multiline
                        disabled={!shouldActOnSection.location_details || state?.viewOnly}
                        value={locationComment}
                        onChange={(e) => setLocationComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                      />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                        <Badge bg={`${locationComment?.length > characterLimit ? 'danger' : 'primary'}`}>{locationComment?.length}/{characterLimit}</Badge>
                      </div>
                    </Grid>
                    <Grid item xs={2}>
                      <FormGroup>
                        <FormControlLabel control={<Switch disabled={!shouldActOnSection.location_details || state?.viewOnly} checked={locationDetailsSectionOk}
                          onChange={(e) => setLocationDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2">
                            {t('reg.detailsOk')}?
                          </Typography>} />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" disabled={!shouldActOnSection.location_details || state?.viewOnly}
                        onClick={() => onSaveComment(locationComment, "location_details", locationDetailsSectionOk)}
                        startIcon={<CommentIcon />}
                      >
                        {t('preReg.addComment')}
                      </Button>
                    </Grid>
                  </Grid>
                    <div>
                      <Accordion mt={1} >
                        <AccordionSummary
                          expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
                        >
                          <Typography variant="subtitle1" ml={2}>{t('reg.commentHistory')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box style={{ height: 300, width: '100%' }}>
                            <DataGrid
                              rows={locationComments ? locationComments : []}
                              columns={commentsColumn}
                              pageSize={10}
                              getRowHeight={() => 'auto'} />
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div></>}
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            {!showWorkFlowButtons &&
              <Button
                sx={{ minWidth: 100 }}
                variant="contained"
                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                onClick={() => { (!_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                startIcon={<SaveIcon />}
              >{t('preReg.save')}
              </Button>
            }
            <Button
              sx={{ minWidth: 100, ml: 1 }}
              variant="contained"
              onClick={() => checkValidations1()}
              startIcon={<PreviewIcon />}
            >{t('preReg.preview')}</Button>
          </Box>
        </Container>}
        {currentPage === "preview" &&
          <Grid xs={12} md={12} id='divPreview'>
            <Preview urn={urn} goBack={onGoBack} callWorkFlowApi={callWorkFlowApi} stakeholderType="LLE" />
          </Grid>}
      </>
    </LleContext.Provider>
  )
}
export default RegistrationDetailsLle;

export const useLleContextData = () => useContext(LleContext)